import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../Sidebar/Sidebar.jsx";
import Topbar from "../Topbar/Topbar.jsx";
import Ticketsadd from "./TicketsCreate.jsx";
import "../../Modules/Tickets/Ticketsadd.css";
import backarrow from "../../Assets/svg/backarrow.svg";
import set from "../../Assets/svg/set.svg";
import nan from "../../Assets/png/nan.png";
import sak from "../../Assets/png/sak.png";
import green from "../../Assets/svg/green.svg";
import excel from "../../Assets/png/excel.png";
import download from "../../Assets/svg/download.svg";
import note from "../../Assets/png/note.png";
import play from "../../Assets/svg/play.svg";
import pause from "../../Assets/svg/pause.svg";
import editHistory from "../../Assets/svg/edit_historyc.svg";
import time from "../../Assets/svg/time.svg";
import close from "../../Assets/svg/close.svg";
import arrows from "../../Assets/svg/arrows.svg";
import calendar from "../../Assets/svg/calendar.svg";
import completeIcon from "../../Assets/svg/completed-status.svg";
import createdIcon from "../../Assets/svg/created-status.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../Assets/svg/close-modal.svg";
import { Form, Button, InputGroup, Toast, ToastContainer } from "react-bootstrap";
import UserImg from "../../Assets/png/user-icon.png";
import { subDays, addDays, format, parse } from "date-fns";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/calendar.svg";
import moment from "moment";
import { yellow } from "@mui/material/colors";
import greyIcon from "../../Assets/svg/grey.svg";
import yellowIcon from "../../Assets/svg/yellow.svg";
import totalEstIcon from "../../Assets/svg/total-est.svg";
import developmentIcon from "../../Assets/svg/development.svg";
import designIcon from "../../Assets/svg/design.svg";
import testingIcon from "../../Assets/svg/testing.svg";
import rectangle from "../../Assets/svg/rectangle.svg";
import subTicketIcon from "../../Assets/svg/sub-ticket-icon.svg";
import ReactPaginate from "react-paginate";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import { useGlobal } from "../../GlobalContext.js";
import downloadIcon from "../../Assets/svg/download-icon.svg";
import EditIocns from "../../Assets/svg/single_edit_ic.svg";
import CloseIocns from "../../Assets/svg/close-modal.svg";
import tickIocns from "../../Assets/svg/tick_icon.svg";
import LoaderModal from "../common/Loader.js";
import StatusUpdateModal from "./modal/status-update.js";
import parseHtml from "html-react-parser";
import HtmlContent from "../common/html-content";
import { billingUpdateApi, descriptionDetailUpdateApi, getEnabledFieldApi, othersDetailUpdateApi, ticketDetailUpdateApi, titleUpdateApi } from "./Ticketapi.js";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { ReactComponent as ViewDetails } from "../../Assets/view_details.svg";
import { apiCall } from "../../services/api-service.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./Ticketsview.css";
import BulkEditCard, { BulkEditTimeline } from "../common/bulkEditCard.jsx";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { getAttachmentIcon } from "../common/attachment-icon";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useUI } from "../../UIContext";

const TicketDateInput = React.forwardRef(function TicketDateInput({ value, onClick, placeholder }, ref) {
  return (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly
      className="form-control w-100"
      style={{
        height: "40px",
        borderRadius: "10px",
        border: "0.7px solid #E5E5E5",
        padding: "16px",
        cursor: "pointer",
      }}
      placeholder={placeholder}
    />
  );
});

const Ticketview = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  // const location = useLocation();

  const [enabledFields, setEnabledFields] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [fieldLabels, setFieldLabels] = useState({});
  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? []);
        setMandatoryFields(response?.mandatory_fields ?? []);
        setFieldLabels(response?.application_labels ?? response?.labels ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const isFieldEnabled = (field) => {
    if (field === "Customer") {
      return enabledFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return enabledFields.some((item) => item === field);
  };
  const isFieldMandatory = (field) => {
    if (field === "Title" || field === "Project") return true;
    if (!isFieldEnabled(field)) return false;
    if (field === "Customer" || field === "Client Name") {
      return mandatoryFields.some((item) => item === "Customer" || item === "Client Name");
    }
    return mandatoryFields.some((item) => item === field);
  };
  const getFieldLabel = (fieldKey, defaultLabel = fieldKey) => {
    let custom = fieldLabels?.[fieldKey];
    if ((!custom || typeof custom !== "string" || custom.trim() === "") && (fieldKey === "Customer" || fieldKey === "Client Name")) {
      custom = fieldLabels?.["Customer"] || fieldLabels?.["Client Name"];
    }
    if (custom && typeof custom === "string" && custom.trim() !== "") {
      return custom.trim();
    }
    return defaultLabel;
  };
  const renderFieldLabel = (fieldKey, defaultLabel, extra = null, overrideText = null, isMandatoryExplicit = null) => {
    const labelText = overrideText ?? (fieldKey === "Level" && defaultLabel ? defaultLabel : getFieldLabel(fieldKey, defaultLabel));
    const isMandatory = isMandatoryExplicit !== null ? isMandatoryExplicit : isFieldMandatory(fieldKey);
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          verticalAlign: "middle",
        }}
      >
        <span
          title={labelText}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
        >
          {labelText}
        </span>
        {isMandatory && <span style={{ color: "red", marginLeft: "3px", flexShrink: 0 }}> *</span>}
        {extra}
      </span>
    );
  };
  const navigate = useNavigate();
  // const { sid } = useParams();
  function sanitizeDescription(desc) {
    if (!desc) return "";

    let safe = desc
      .replace(/\\r\\n/g, " ")
      .replace(/\\\//g, "/")
      .replace(/\[cid:[^\]]+\]/gi, "");

    // Handle <mailto:...>
    safe = safe.replace(/<mailto:([^>]+)>/gi, (_, email) => {
      return `<a href="mailto:${email}">${email}</a>`;
    });

    // Handle email@domain<mailto:email@domain>
    safe = safe.replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,})<mailto:\1>/gi, (_, email) => `<a href="mailto:${email}">${email}</a>`);

    // Handle <http(s)://...>
    safe = safe.replace(/<https?:\/\/([^>]+)>/gi, (_, url) => {
      return `<a href="https://${url}" target="_blank">${url}</a>`;
    });

    // Handle plain www.*
    safe = safe.replace(/(^|\s)(www\.[^\s]+)/gi, (_, space, url) => {
      return `${space}<a href="https://${url}" target="_blank">${url}</a>`;
    });

    return safe;
  }

  const filterTypes = [
    { label: "Except comment", value: "except_comment" },
    { label: "With comment", value: "" },
  ];

  const location = useLocation();
  const { id } = useParams(); // works if route has /ticket/view/:id
  function getToday() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  // // Query param
  // const queryParams = new URLSearchParams(location.search);
  // const queryId = queryParams.get("id");

  // // Final ticket id (query > route > state)
  // const { id: stateId } = location.state || {};
  // const id = queryId || routeId || stateId || null;

  console.log("Ticket ID:", id);
  // const { id } = location.state || {}; // Default empty object
  const { rolePermissionList } = useGlobal();
  const { isCollapsed } = useUI();
  // function checkPermission(menuName, permission) {
  //   return rolePermissionList.findIndex(
  //     (element) =>
  //       element["name"] === menuName &&
  //       element["menu_permission"] === true &&
  //       element[permission] === true
  //   ) > -1
  //     ? true
  //     : false;
  // }

  const [additionalPermissionList, setAdditionalPermissionList] = useState([]);
  const [ticketDetail, setTicketDetail] = useState({});
  const [empId, setEmpId] = useState(0);
  const [subTicketDetail, setSubTicketDetails] = useState(null);
  const [attachmentList, setAttachmentList] = useState([]);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [previewImageName, setPreviewImageName] = useState("");
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [workflowList, setWorkflowList] = useState([]);
  const [editHistoryList, setEditHistoryList] = useState([]);
  const [commentsList, setCommentsList] = useState([]);
  const [totalCommentCount, setTotalCommentCount] = useState(0);

  const [tabView, setTabView] = useState(location.state?.fromTab || "Comments");
  useEffect(() => {
    if (location.state?.fromTab) {
      setTabView(location.state.fromTab);
    }
  }, [location.state?.fromTab, id]);
  const [listingType, setListingType] = useState("All");
  const [inProgressList, setInProgressData] = useState([]);

  const [titleEdit, settitleEdit] = useState(false);
  const [ticketDetEdit, setticketDetEdit] = useState(false);
  const [ticketOtherDetEdit, setticketOtherDetEdit] = useState(false);
  const [ticketDesprictionEdit, setticketDesprictionEdit] = useState(false);
  const [ticketBillingEdit, setticketBillingEdit] = useState(false);
  const [titleeditValue, settitleeditValue] = useState("");

  const [subTicketTotalEst, setSubTicketTotalEst] = useState(0);
  const [subTicketEstList, setSubTicketEstList] = useState([]);
  const [subTicketList, setSubTicketList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [remarksInputValue, setRemarksInputValue] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(null);

  const [loading, setLoading] = useState(false);
  const [expectedDate, setExpectedDate] = useState("");
  const [closingDate, setClosingDate] = useState("");
  const [workDuration, setWorkDuration] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [rating, setRating] = useState(0);
  const [selectedReferenceOption, setReferenceOption] = useState(null);

  const [validations, setValidations] = useState({
    expected_date: "",
    description: "",
    work_duration: "",
    closing_date: "",
    remarks: "",
  });
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Ticket" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  function pagePermission(menuName) {
    const index = rolePermissionList.findIndex((element) => element["name"] === menuName);
    return index > -1 ? rolePermissionList[index] : {};
  }
  useEffect(() => {
    getEnabledField();
  }, []);
  useEffect(() => {
    if (titleEdit) {
      setValidationstitle({
        title: "",
      });
      settitleeditValue(ticketDetail.title);
    }
  }, [titleEdit]);
  // Edit API....

  const [validationstitle, setValidationstitle] = useState({
    title: "",
  });
  const updateTitle = async () => {
    setValidationstitle({
      title: "",
    });
    try {
      const bodyData = { title: titleeditValue };

      const response = await titleUpdateApi(bodyData, id);

      // ✅ Success path
      if (response?.success) {
        settitleEdit(false);
        setSnackbarMessage(response.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getTicketData();
        getEditHistory();
      } else if (response?.status === 400) {
        const validationTemp = { ...validations };

        Object.keys(validationTemp).forEach((key) => {
          validationTemp[key] = "";
        });

        Object.entries(response.data.error ?? {}).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
        });

        setValidationstitle(validationTemp);
        setSnackbarMessage(response.data?.message || "Validation failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error updating title:", error);
      // ✅ Handle validation or server errors
      if (error.response) {
        const { status, data } = error.response;
        console.error("Error Status:", status);
        console.error("Error Data:", data);

        setSnackbarMessage(data?.message || "Something went wrong");
        setSnackbarStatus(false);
        handleSnackbarShow();
      } else {
        console.error("Unexpected Error:", error);
        setSnackbarMessage("Unexpected error occurred");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    }
  };
  const [validationstickDet, setValidationsTicketDet] = useState({
    project_id: "",
    levels: "",
    priority: "",
  });
  const updateTicketDetails = async () => {
    setValidationsTicketDet({
      project_id: "",
      levels: "",
      priority: "",
    });
    setLoading(true);
    try {
      const bodyData = {
        project_id: selectedProjectOption?.value ? selectedProjectOption.value : null,
        levels: (levelOptionList || []).filter((item) => item && item.value !== "").map((item) => item.value),
        priority: priority,
      };
      console.log("project_id", selectedProjectOption.value);
      console.log("prohect", bodyData);
      const response = await ticketDetailUpdateApi(bodyData, id);

      if (response?.success) {
        setticketDetEdit(false);
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
        getTicketData();
        getEditHistory();
      } else if (response?.status === 400) {
        const validationTemp = { ...validations };

        Object.keys(validationTemp).forEach((key) => {
          validationTemp[key] = "";
        });

        Object.entries(response.data.error ?? {}).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
        });

        setValidationsTicketDet(validationTemp);
        setSnackbarMessage(response.data?.message || "Validation failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);

        setSnackbarMessage(error.response.data?.message || "Something went wrong");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } finally {
      setLoading(false);
    }
  };
  const [validationsOtherDet, setValidationsOtherDet] = useState({
    est: "",
    assignee: "",
    reporter_id: "",
    team_id: "",
    created: "",
    expected: "",
    remarks: "",
  });
  const updateOtherDetails = async () => {
    if (!otherRemarks.trim()) {
      setValidationsOtherDet((prev) => ({
        ...prev,
        remarks: "Remarks is required",
      }));
      return;
    }

    setLoading(true);
    setValidationsOtherDet({
      est: "",
      assignee: "",
      reporter_id: "",
      team_id: "",
      created: "",
      expected: "",
      remarks: "",
    });
    try {
      const bodyData = {
        est: estimation,
        assignee: selectedAssignToOption?.value || null,
        reporter_id: selectedEmailOption?.value || null,
        team_id: selectedTeamOption?.value || null,
        created: createdEditDate,
        expected: expectedEditDate,
        remarks: otherRemarks.trim() || null,
      };

      const response = await othersDetailUpdateApi(bodyData, id);

      if (response?.success) {
        setticketOtherDetEdit(false);
        setOtherRemarks("");
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
        getTicketData();
        getEditHistory();
      } else if (response?.status === 400) {
        const validationTemp = {
          est: "",
          assignee: "",
          reporter_id: "",
          team_id: "",
          created: "",
          expected: "",
          remarks: "",
        };

        Object.entries(response.data.error ?? {}).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : (typeof value === "string" ? value : "");
        });

        setValidationsOtherDet(validationTemp);
        setSnackbarMessage(response.data?.message || "Validation failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error Status:", error);
      console.error("Error Data:", error.response?.data);

      setSnackbarMessage(error.response?.data?.message || "Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setLoading(false);
    }
  };
  const [validationsdescropt, setValidationsDescript] = useState({
    description: "",
    action_plan: "",
  });
  const updateDescriptionDetails = async () => {
    setValidationsDescript({
      description: "",
      action_plan: "",
    });
    setLoading(true);
    try {
      const bodyData = {
        description: descriptionEdit,
        action_plan: actionPlanEdit,
      };

      const response = await descriptionDetailUpdateApi(bodyData, id);

      if (response?.success) {
        setticketDesprictionEdit(false);
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
        getTicketData();
        getEditHistory();
      } else if (response?.status === 400) {
        const validationTemp = { ...validations };

        Object.keys(validationTemp).forEach((key) => {
          validationTemp[key] = "";
        });

        Object.entries(response.data.error ?? {}).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
        });

        setValidationsDescript(validationTemp);
        setSnackbarMessage(response.data?.message || "Validation failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error Status:", error);
      console.error("Error Data:", error.response.data);

      setSnackbarMessage(error.response.data?.message || "Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setLoading(false);
    }
  };
  const [validationsbilling, setValidationsBilling] = useState({
    is_billable: "",
    customer_id: "",
    vendor_id: "",
    reference_id: "",
  });
  const updateBillingDetails = async () => {
    setValidationsBilling({
      is_billable: "",
      customer_id: "",
      reference_id: "",
      vendor_id: "",
    });
    setLoading(true);
    try {
      const bodyData = {
        is_billable: isBillingChecked,
        customer_id: selectedCustomerOption?.value || 0,
        reference_id: selectedReferenceOption?.value || 0,
        vendor_id: selectedVendorOption?.value || 0,
      };

      const response = await billingUpdateApi(bodyData, id);

      if (response?.success) {
        setticketBillingEdit(false);
        setSnackbarMessage(response.message);
        setSnackbarStatus(response.success);
        handleSnackbarShow();
        getTicketData();
        getEditHistory();
      } else if (response?.status === 400) {
        const validationTemp = { ...validations };

        Object.keys(validationTemp).forEach((key) => {
          validationTemp[key] = "";
        });

        Object.entries(response.data.error ?? {}).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
        });

        setValidationsBilling(validationTemp);
        setSnackbarMessage(response.data?.message || "Validation failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error("Error Status:", error);
      console.error("Error Data:", error.response.data);

      setSnackbarMessage(error.response.data?.message || "Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (checkPermission("view_permission")) {
      const index = rolePermissionList.findIndex((element) => element["name"] === "Ticket");
      if (index > -1) {
        setAdditionalPermissionList(rolePermissionList[index].additional_permissions_list);
      }
      getTicketDetails();

      document.cookie = "ticketView=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      getTicketData();
      getSubTicketEstimation();
      getSubTicketList("");
      getAttachmentList();
      getCommentsList("");
      getWorkflowList();
      getEditHistory();
      getInprogressList();
    }
  }, [id, location.state?.refresh]);



  // ticket details edit
  const [priority, setPriority] = useState("Low");
  const [selectedParentTicketOption, setParentTicketOption] = useState(null);
  const [selectedProjectOption, setProjectOption] = useState(null);
  const [levelOptionList, setLevelOptionList] = useState([{ value: "", label: "" }]);
  const handleProjectDropdownChange = (option) => {
    setProjectOption(option);
  };
  const handleLevelListDropdownChange = (option, onChangeIndex) => {
    const idx = onChangeIndex?.parentIndex ?? 0;
    const tempList = [...levelOptionList].slice(0, idx);

    if (option && option.value) {
      tempList.push(option);
      tempList.push({ value: "", label: "" });
    } else {
      tempList.push({ value: "", label: "" });
    }

    setLevelOptionList(tempList);
  };
  const getLevelParams = (index) => {
    if (index === 0) {
      return {
        project_id: (selectedProjectOption && selectedProjectOption?.value) ?? "",
      };
    } else {
      return {
        parent_id: levelOptionList && levelOptionList[index - 1] != null ? (levelOptionList[index - 1]?.value ?? "") : "",
      };
    }
  };
  function formatEditDate(inputDate) {
    console.log("inputDate...........", inputDate);
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
            console.log('parsedDate...........',parsedDate);
        // Format the date
        return format(parsedDate, "yyyy-MM-dd"); */
        return moment(inputDate).format("YYYY-MM-DD");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
  // Other Ticket Edit
  const [estimation, setEstimation] = useState("");
  const [expectedEditDate, setExpectedEditDate] = useState("");
  const [initialExpectedDate, setInitialExpectedDate] = useState("");
  const [createdEditDate, setCreatedEditDate] = useState("");
  const [otherRemarks, setOtherRemarks] = useState("");
  const [selectedTeamOption, setTeamOption] = useState(null);
  const [selectedAssignToOption, setAssignToOption] = useState(null);
  const [selectedEmailOption, setEmailOption] = useState(null);

  const parseTicketDate = (value) => {
    if (!value) {
      return null;
    }

    const parsed = moment(value, ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm", "YYYY-MM-DD", "DD-MM-YYYY HH:mm", "DD-MM-YYYY"], true);

    if (parsed.isValid()) {
      return parsed;
    }

    const fallback = moment(value);
    return fallback.isValid() ? fallback : null;
  };

  const getExpectedDateFromCreateAndEstimation = (createdDateValue, estimationValue) => {
    if (!createdDateValue || !estimationValue) {
      return "";
    }

    const match = estimationValue.match(/^(\d{1,2}):(\d{1,2})$/);
    if (!match) {
      return "";
    }

    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (Number.isNaN(hours) || Number.isNaN(minutes) || minutes > 59) {
      return "";
    }

    const createdMoment = parseTicketDate(createdDateValue);
    if (!createdMoment) {
      return "";
    }

    return createdMoment.clone().add(hours, "hours").add(minutes, "minutes").format("YYYY-MM-DDTHH:mm");
  };

  const handleCreateDateChange = (date) => {
    const newCreateDate = date ? moment(date).format("YYYY-MM-DDTHH:mm") : "";

    setCreatedEditDate(newCreateDate);

    const calculatedExpected = getExpectedDateFromCreateAndEstimation(newCreateDate, estimation);
    if (calculatedExpected) {
      setExpectedEditDate(calculatedExpected);
      setValidationsOtherDet((prev) => ({ ...prev, expected: "", created: "" }));
      return;
    }

    // update expectedDate only if createdDate > expectedDate
    if (newCreateDate && expectedEditDate && moment(newCreateDate).isAfter(moment(expectedEditDate))) {
      setExpectedEditDate(newCreateDate);
    }
    setValidationsOtherDet((prev) => ({ ...prev, created: "" }));
  };
  const handleExpectedDateChange = (date) => {
    if (date !== undefined) {
      setExpectedEditDate(moment(date).format("YYYY-MM-DDTHH:mm"));
      setValidationsOtherDet((prev) => ({ ...prev, expected: "" }));
      setShowPicker(false);
    }
  };
  const handleCreatedDateChange = (date) => {
    if (date !== undefined) {
      console.log(moment(date).format("YYYY-MM-DDTHH:mm"));
      setCreatedEditDate(moment(date).format("YYYY-MM-DDTHH:mm"));
      setShowPicker(false);
    }
  };
  const handleAssignToDropdownChange = (option) => {
    setAssignToOption(option);
  };
  const handleTeamDropdownChange = (option) => {
    setTeamOption(option);
  };
  const handleEmailDropdownChange = (option) => {
    setEmailOption(option);
  };

  const handleRefernceDropdownChange = (option) => {
    setReferenceOption(option);
  };

  const getReferenceParams = () => {
    return {
      customer_id: selectedCustomerOption != null ? selectedCustomerOption.value : "",
    };
  };
  // Description

  const [descriptionEdit, setDescriptionEdit] = useState("");
  const [actionPlanEdit, setActionPlanEdit] = useState("");
  // Billing Details
  const [selectedCustomerOption, setCustomerOption] = useState(null);
  const [selectedVendorOption, setVendorOption] = useState(null);
  const handleCustomerDropdownChange = (option) => {
    setCustomerOption(option);
  };
  const handleVendorDropdownChange = (option) => {
    setVendorOption(option);
  };
  const [isBillingChecked, setIsBillingChecked] = useState(false);
  const handleCheckboxChange = (e) => {
    if (e.target) {
      setIsBillingChecked(e.target.checked);
      setVendorOption(null);
      setCustomerOption(null);
    }
  };
  useEffect(() => {
    if (checkPermission("view_permission")) {
      getSubTicketList("");
    }
    /*  getListCount(); */
  }, [listingType, itemsPerPage, itemOffset]);
  const getTicketData = async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", `ticket/view/${id}`);
      if (response?.data?.success === true) {
        setEmpId(response.data.emp_id ?? 0);
        setTicketDetail({ ...response.data.ticket, fetchedAt: new Date() });
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };

  const getAttachmentList = async () => {
    try {
      const response = await apiCall("get", `ticket/attachment/${id}`);
      if (response?.data?.success === true) {
        setAttachmentList(response.data.attachments);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const saveAttachment = async (base64, name) => {
    setLoading(true);
    try {
      const data = {
        attachment: base64,
        attachment_name: name,
      };
      const response = await apiCall("put", `ticket/add_attachment/${id}`, data);
      if (response?.data?.success === true) {
        getAttachmentList();
      }
      setSnackbarMessage(response?.data?.message || "Something went wrong");
      setSnackbarStatus(Boolean(response?.data?.success));
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const updateApproval = async (status) => {
    setLoading(true);
    try {
      const data = {
        status: status, // Approved, Rejected
        description: remarksInputValue,
      };
      const response = await apiCall("put", `ticket/approval_update/${id}`, data);
      if (response?.data?.success === true) {
        getTicketData();
      }
      setSnackbarMessage(response?.data?.message || "Something went wrong");
      setSnackbarStatus(Boolean(response?.data?.success));
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
      setIsOpenApprove("");
      setIsOpenApproveUpdate(false);
    }
  };
  const removeAttachment = async (attachmentId) => {
    setLoading(true);
    try {
      const response = await apiCall("put", `ticket/remove_attachment/${attachmentId}`, {});
      if (response?.data?.success === true) {
        setAlertIndex(null);
        getAttachmentList();
      }
      setSnackbarMessage(response?.data?.message || "Something went wrong");
      setSnackbarStatus(Boolean(response?.data?.success));
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const getCommentsList = async (seeMore) => {
    try {
      const params =
        seeMore === ""
          ? {}
          : {
              limit: 10,
              skip: commentsList.length,
            };
      const response = await apiCall("get", `ticket/comment/${id}`, null, {
        params,
      });
      if (response?.data?.success === true) {
        setTotalCommentCount(response.data.total_rec);
        if (seeMore !== "" && response.data.comments.length > 0) {
          setCommentsList((prev) => [...prev, ...response.data.comments]);
        } else {
          setCommentsList(response.data.comments);
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const saveComment = async () => {
    setLoading(true);
    try {
      const data = {
        comment: descriptionInputValue,
      };
      const response = await apiCall("put", `ticket/add_comment/${id}`, data);
      if (response?.data?.success === true) {
        closeCommentModal();
        getCommentsList("");
      }
      setSnackbarMessage(response?.data?.message || "Something went wrong");
      setSnackbarStatus(Boolean(response?.data?.success));
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const getWorkflowList = async () => {
    try {
      const response = await apiCall("get", `ticket/workflow/${id}`);
      if (response?.data?.success === true) {
        setWorkflowList(response.data.histories);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEditHistory = async () => {
    try {
      const response = await apiCall("get", `ticket/history/${id}`);
      if (response?.data?.success === true) {
        setEditHistoryList(response.data.histories);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const statusUpdate = async (status) => {
    const data = {
      status: status,
    };
    if (status === "Hold") {
      data["expected_date"] = expectedDate;
      data["description"] = descriptionInputValue;
    }
    if (status === "Closed") {
      data["work_duration"] = workDuration;
      data["closing_date"] = closingDate;
      data["description"] = descriptionInputValue;
    }
    if (status === "Completed") {
      data["rating"] = rating;
      data["description"] = descriptionInputValue;
    }

    const response = await apiCall("put", `ticket/status_update/${subTicketDetail != null ? subTicketDetail.id : id}`, data);

    if (response?.status === 200 && response?.data?.success === true) {
      closeStatusUpdateModal();
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      getTicketData();
      if (subTicketDetail == null) {
        getWorkflowList(id);
      } else {
        setSubTicketDetails(null);
        getInprogressList();
        getSubTicketList("");
      }
      try {
        await getCommentsList("");
      } catch (err) {
        console.error("Error refreshing comments list:", err);
      }
      return;
    }

    if (response?.status === 400 && response?.data?.error) {
      const nextValidations = {
        expected_date: "",
        description: "",
        work_duration: "",
        closing_date: "",
        remarks: "",
      };

      Object.entries(response.data.error).forEach(([key, value]) => {
        nextValidations[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
      });
      setValidations(nextValidations);
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const isImageAttachment = (attachment) => {
    const mimeType = (attachment?.mime_type ?? attachment?.content_type ?? attachment?.type ?? "").toString().toLowerCase();

    if (mimeType.startsWith("image/")) {
      return true;
    }

    const fileSource = (attachment?.name ?? attachment?.url ?? "").toString().toLowerCase().split("?")[0].split("#")[0];

    const extension = fileSource.includes(".") ? fileSource.substring(fileSource.lastIndexOf(".") + 1) : "";

    return ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension);
  };

  const openImagePreview = (attachment) => {
    if (!attachment?.url || !isImageAttachment(attachment)) {
      return;
    }

    setPreviewImageUrl(attachment.url);
    setPreviewImageName(attachment.name ?? "Attachment Image");
    setIsImagePreviewOpen(true);
  };

  const closeImagePreview = () => {
    setIsImagePreviewOpen(false);
    setPreviewImageUrl("");
    setPreviewImageName("");
  };
  const getStatusIcon = (status) => {
    switch (status) {
      case "Created":
        return createdIcon;

      case "In Progress":
        return play;

      case "Hold":
        return pause;

      case "Closed":
        return close;

      case "Completed":
        return completeIcon;
      default:
        return play;
    }
  };
  const [isOpenComment, setIsOpenComment] = useState(false);
  const closeCommentModal = () => {
    setIsOpenComment(false);
    setDescriptionInputValue("");
  };

  const commentModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "520px",
      height: "313px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const [isOpenHold, setIsOpenHold] = useState(false);
  const [isOpenApprove, setIsOpenApprove] = useState("");

  const closeHoldModal = () => {
    setIsOpenHold(false);
    setExpectedDate(null);
    setDescriptionInputValue("");
  };
  const holdModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "520px",
      height: "425px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const [isOpenClose, setIsOpenClose] = useState(false);
  const [isOpenStatusUpdate, setIsOpenStatusUpdate] = useState(false);
  const [isOpenApproveUpdate, setIsOpenApproveUpdate] = useState(false);

  useEffect(() => {
    if (isOpenStatusUpdate && isOpenClose && !workDuration) {
      const detail = subTicketDetail || ticketDetail;
      const rawDuration = detail?.syslogged_duration || detail?.duration || detail?.total_duration || detail?.est;
      if (rawDuration && rawDuration !== "--:--") {
        const timeStr = String(rawDuration).split(".")[0];
        const parts = timeStr.split(":");
        if (parts.length >= 2) {
          setWorkDuration(`${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`);
        } else {
          setWorkDuration(timeStr);
        }
      }
    }
  }, [isOpenStatusUpdate, isOpenClose, subTicketDetail, ticketDetail, workDuration]);
  const closeStatusUpdateModal = () => {
    setIsOpenHold(false);
    setIsOpenClose(false);
    setIsOpenStatusUpdate(false);
    setWorkDuration("");
    setClosingDate(null);
    setExpectedDate(null);
    setDescriptionInputValue("");
    setValidations((validation) => {
      const validationTemp = validation;
      Object.entries(validationTemp).forEach(([key, value]) => {
        console.log(`${key}: ${value}`);
        validationTemp[key] = "";
      });

      console.log(validationTemp);
      return validationTemp;
    });
  };
  const closeApproveModal = () => {
    setIsOpenApprove("");
    setIsOpenApproveUpdate(false);
    setRemarksInputValue("");
    setValidations((validation) => {
      const validationTemp = validation;
      Object.entries(validationTemp).forEach(([key, value]) => {
        console.log(`${key}: ${value}`);
        validationTemp[key] = "";
      });

      console.log(validationTemp);
      return validationTemp;
    });
  };

  const closeticketDetModal = () => {
    setPriority("");
    setProjectOption(null);
    setLevelOptionList([{ value: "", label: "" }]);
    setticketDetEdit(false);
  };
  const openticketDetModal = async () => {
    setValidationsTicketDet({
      project_id: "",
      levels: "",
      priority: "",
    });
    const data = await getTicketDetails();
    setPriority(data.priority ?? "Low");
    setProjectOption({
      label: data.project ?? "",
      value: data.project_id ?? 0,
    });
    setLevelOptionList(Array.isArray(data?.levels) && data.levels.length > 0 ? data.levels : [{ value: "", label: "" }]);

    setticketDetEdit(true);
  };
  const closeticketOtherDetModal = () => {
    setticketOtherDetEdit(false);
    setOtherRemarks("");
    setValidationsOtherDet({
      est: "",
      assignee: "",
      reporter_id: "",
      team_id: "",
      created: "",
      expected: "",
      remarks: "",
    });
  };
  const closeDescriptionModal = () => {
    setticketDesprictionEdit(false);
  };
  const closeBillingDetailsModal = () => {
    setticketBillingEdit(false);
  };
  const [resultData, setresultData] = useState(false);
  const getTicketDetails = async () => {
    setLoading(true);
    try {
      const response = await apiCall("get", `ticket/edit/${id}`);

      if (response.data.success === true) {
        const ticket = response.data.ticket;
        setresultData(ticket); // keep updating state
        return ticket; // ✅ return fresh data
      }
      return null; // return null if not successful
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);
      } else {
        console.error("Request failed:", error.message);
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  const openticketOtherDetModal = async () => {
    setOtherRemarks("");
    setValidationsOtherDet({
      est: "",
      assignee: "",
      reporter_id: "",
      team_id: "",
      created: "",
      expected: "",
      remarks: "",
    });
    const data = await getTicketDetails();
    if (data) {
      setEstimation(data.est === "00:00" || data.est === "00:00:00" ? "" : (data.est?.substring(0, 5) ?? ""));
      const createdStr = parseTicketDate(data.created)?.format("YYYY-MM-DDTHH:mm") ?? "";
      const expectedStr = parseTicketDate(data.expected)?.format("YYYY-MM-DDTHH:mm") ?? "";
      setCreatedEditDate(createdStr);
      setExpectedEditDate(expectedStr);
      setInitialExpectedDate(expectedStr);
      data.reporter_id &&
        setEmailOption({
          value: data.reporter_id,
          label: data.reporter_email ?? "",
        });
      data.team_id &&
        setTeamOption({
          value: data.team_id,
          label: data.team ?? "",
        });
      data.assignee_id &&
        setAssignToOption({
          value: data.assignee_id,
          label: data.assignee ?? "",
        });
    }

    setticketOtherDetEdit(true);
  };
  const openticketDetailsModal = async () => {
    setValidationsDescript({
      description: "",
      action_plan: "",
    });
    const data = await getTicketDetails();
    if (data) {
      setDescriptionEdit(
        (data.description ?? "")
          .replace(/\\r\\n/g, "") // remove escaped \r\n
          .replace(/\\r/g, "") // remove escaped \r
          .replace(/\\n/g, "") // remove escaped \n
          .replace(/\t/g, "") // remove tabs
          .trim(),
      );
      setActionPlanEdit(
        (data.action_plan ?? "")
          .replace(/\\r\\n/g, "")
          .replace(/\\r/g, "")
          .replace(/\\n/g, "")
          .replace(/\t/g, "")
          .trim(),
      );
    }
    setticketDesprictionEdit(true);
  };
  const openBillingDetailsModal = async () => {
    setValidationsBilling({
      is_billable: "",
      customer_id: "",
      vendor_id: "",
      reference_id: "",
    });
    const data = await getTicketDetails();
    if (data) {
      data.customer_id &&
        setCustomerOption({
          value: data.customer_id,
          label: data.customer ?? "",
        });
      data.reference_value &&
        setReferenceOption({
          value: data.reference_value,
          label: data.reference ?? "",
        });
      setIsBillingChecked(true);
      ticketDetail.vendor_id &&
        setVendorOption({
          value: ticketDetail.vendor_id ?? null,
          label: ticketDetail.vendor ?? "",
        });
    }
    setticketBillingEdit(true);
  };
  function convertDate(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const closeModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "520px",
      height: "425px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const closeApproveModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "520px",
      height: "355px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const closeEditModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "20px 24px",
      borderRadius: "16px",
      boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
      width: "560px",
      maxHeight: "90vh",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const [EditshowPicker, setEditShowPicker] = useState(false);
  const [EditCreatedshowPicker, setEditCreatedShowPicker] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDatePicker);
    };
  }, []);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleEditExpectedDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleEditExpectedDatePicker);
    };
  }, []);
  const alertDatePicRef = useRef(null);
  const alertEditPicRef = useRef(null);
  const [alertIndex, setAlertIndex] = useState(null);
  const handleEditExpectedDatePicker = (event) => {
    if (alertEditPicRef.current && !alertEditPicRef.current.contains(event.target)) {
      setEditShowPicker(false);
    }
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };
  const handleCloseDatePicker = (event) => {
    if (alertDatePicRef.current && !alertDatePicRef.current.contains(event.target)) {
      setShowPicker(false);
    }
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };
  const handleDateChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setExpectedDate(moment(date).format("YYYY-MM-DD"));
      setShowPicker(false);
    }
  };
  const handleClosingDateChange = (date) => {
    if (date !== undefined) {
      console.log(moment(date).format("YYYY-MM-DD"));
      setClosingDate(moment(date).format("YYYY-MM-DD"));
      setShowPicker(false);
    }
  };
  function formatDate(inputDate) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy"); */
        return moment(inputDate).format("dddd, DD MMM YYYY");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const getPriorityColor = (p) => {
    const priority = p?.toLowerCase();
    switch (priority) {
      case "high":
        return "#F44336";
      case "medium":
        return "#FFC107";
      case "low":
        return "#4CAF50";
      default:
        return "#E0E0E0";
    }
  };

  const handleChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key);
      if (lastKey === "Backspace") {
        setWorkDuration(inputText);
      } else {
        setWorkDuration(inputText.length === 2 ? inputText + ":" : inputText);
      }
    }
  };

  const handleBlur = () => {
    // Auto-format to HH:MM:SS if possible
    const parts = workDuration.split(":").map((part) => part.padStart(2, "0"));

    if (parts.length === 1) {
      setWorkDuration(`00:00:${parts[0]}`);
    } else if (parts.length === 2) {
      setWorkDuration(`00:${parts[0]}:${parts[1]}`);
    } else if (parts.length === 3) {
      setWorkDuration(`${parts[0]}:${parts[1]}:${parts[2]}`);
    }
  };
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file /* && file.type.startsWith("image/") */) {
      /* const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        console.log("Base64 String:", base64String.toString());
        saveAttachment(await reader.result);
      };
      reader.readAsDataURL(file);  */
      const response = await convertToBase64(file);
      saveAttachment(response, file.name);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const alertRef = useRef(null);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    getSubTicketList(term);
  }, 1000);

  const getSubTicketEstimation = async () => {
    try {
      const response = await apiCall("get", `ticket/subtickets_est/${id}`);
      if (response?.data?.success === true) {
        setSubTicketTotalEst(response.data.total ?? 0);
        setSubTicketEstList(response.data.modules ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };
  const getSubTicketList = async (term) => {
    setLoading(true);
    try {
      const response = await apiCall("get", `ticket/subtickets/${id}`, null, {
        params: {
          limit: itemsPerPage,
          skip: itemOffset,
          status: listingType,
          from_date: "",
          to_date: "",
          search: term,
        },
      });
      if (response?.data?.success === true) {
        setPageCount(response.data.total_pgs);
        setTotalCount(response.data.total_rec);
        setSubTicketList(response.data.tickets);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };

  const getInprogressList = async () => {
    try {
      const response = await apiCall("get", "get_inprogress_tickets", null, {
        params: { main_ticket_id: id },
      });
      if (response?.data?.success === true) {
        const now = new Date();
        const ticketsWithTime = (response.data.tickets ?? []).map((ticket) => ({
          ...ticket,
          fetchedAt: now,
        }));
        setInProgressData(ticketsWithTime);
        /*  inprogressTimer(); */
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % subTicketList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  };
  function checkAdditionalPermission(menuName) {
    if (!checkPermission("additional_permission")) {
      return false;
    }
    return additionalPermissionList.findIndex((element) => element["name"] === menuName && element["permission"] === true) > -1 ? true : false;
  }
  const downloadTicket = async (type) => {
    setLoading(true);
    try {
      const response = await apiCall("get", `ticket/pdf_download/${id}`, null, {
        params: { comments: type === "except_comment" ? false : true },
      });

      if (response?.data?.success === true) {
        const base64String = response.data.base64;
        const fileName = "Ticket_" + ticketDetail.code + "_" + new Date().getTime() + ".pdf";

        const binary = atob(base64String);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        const blob = new Blob([new Uint8Array(array)], {
          type: "application/pdf",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      setSnackbarMessage(response?.data?.message || "Something went wrong");
      setSnackbarStatus(Boolean(response?.data?.success));
      handleSnackbarShow();
      /*  setExcel(response.data.url); */
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setLoading(false);
    }
  };

  function onSuccessStatus() {
    setShowStatusUpdate(false);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getTicketData();
    getWorkflowList();
    getCommentsList("");
  }

  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      {showStatusUpdate && (
        <StatusUpdateModal
          ticketDetail={ticketDetail}
          statusUpdate={updateStatus}
          success={onSuccessStatus}
          onHide={() => {
            setShowStatusUpdate(false);
          }}
        />
      )}
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <Row
              xs={12}
              className="g-2 align-items-center justify-content-between"
              style={{
                backgroundColor: "#F3F6F9",
                padding: "16px 16px 0px 16px",
              }}
            >
              <Col xs={12} sm={6} md={5}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      borderRadius: "100px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (location.state?.parentId) {
                        navigate(`/ticket/view/${location.state.parentId}`, {
                          state: { fromTab: "Merged Tickets", refresh: Date.now(), listing_type: location.state?.listing_type },
                        });
                      } else {
                        navigate("/ticket", { state: { listing_type: location.state?.listing_type } });
                      }
                    }}
                  >
                    <img
                      src={backarrow}
                      style={{
                        width: "16px",
                        height: "10px",
                        margin: "0",
                      }}
                      alt="back"
                    />
                  </div>
                  <div className="style-justify-start" style={{ marginLeft: "12px" }}>
                    <p
                      style={{
                        margin: "0",
                        marginLeft: "15px",
                        fontFamily: "Satoshi",
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#212129",
                        marginTop: "4px",
                      }}
                    >
                      {ticketDetail.code}
                    </p>
                    {ticketDetail.status != null && ticketDetail.status != "" && (
                      <div className="style-justify-start" style={{ marginTop: "4px", marginLeft: "8px", padding: "6px 8px", borderRadius: "6px", backgroundColor: "#FFFFFF" }}>
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "4px", // make it slightly rounded, or remove for sharp

                            backgroundColor:
                              ticketDetail.status === "Open"
                                ? "#9E9E9E" // green
                                : ticketDetail.status === "In Progress"
                                  ? "#4CAF50" // yellow
                                  : ticketDetail.status === "Hold"
                                    ? "#FFC107" // red
                                    : "#F44336", // default gray
                            flexShrink: 0,
                          }}
                        ></span>
                        <p className="p13 ms-1">{ticketDetail.status}</p>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={7}>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                  {ticketDetail.id && (
                    <DropdownButton
                      id="dropdown-basic-button"
                      title={
                        <>
                          <img src={downloadIcon} style={{ width: "14px", height: "14px" }} alt="" />
                          <span>Download Ticket</span>
                        </>
                      }
                      className="download-dropdown-btn"
                    >
                      {filterTypes.map((item) => {
                        return <Dropdown.Item key={item.value} onClick={() => downloadTicket(item.value)}>{item.label ?? ""}</Dropdown.Item>;
                      })}
                    </DropdownButton>
                  )}

                  {checkAdditionalPermission("Status update") && (ticketDetail.status === "Open" || ticketDetail.status === "Hold" || ticketDetail.status === "Reopen") && ticketDetail.status !== "Merged" && (ticketDetail.approval_status === null || ticketDetail.approval_status === "Approved") && (
                    <div
                      onClick={() => {
                        statusUpdate("In Progress");
                      }}
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.6px solid #E5E5E5",
                        padding: "10px 28px",
                        backgroundColor: "#3253EB",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "700",
                          lineHeight: "18.9px",
                          margin: "0",
                          color: "#FFFFFF",
                        }}
                      >
                        {ticketDetail.status === "Open" ? "Start Progress" : "Resume"}
                      </p>
                    </div>
                  )}
                  {checkAdditionalPermission("Status update") && ticketDetail.sub_ticket_status === "Closed" && ticketDetail.status === "In Progress" && ticketDetail.status !== "Merged" && (ticketDetail.approval_status === null || ticketDetail.approval_status === "Approved") && (
                    <div
                      onClick={() => {
                        setUpdateStatus("Hold");
                        setShowStatusUpdate(true);
                      }}
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.6px solid #E5E5E5",
                        padding: "10px 28px",
                        backgroundColor: "#3253EB",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "700",
                          lineHeight: "18.9px",
                          margin: "0",
                          color: "#FFFFFF",
                        }}
                      >
                        Hold
                      </p>
                    </div>
                  )}
                  {checkAdditionalPermission("Status update") &&
                    /* ticketDetail.sub_ticket_status === "Closed" && */
                    (ticketDetail.status === "In Progress" || ticketDetail.status === "Hold") &&
                    ticketDetail.status !== "Merged" &&
                    (ticketDetail.approval_status === null || ticketDetail.approval_status === "Approved") && (
                      <div
                        onClick={() => {
                          setUpdateStatus("Closed");
                          setShowStatusUpdate(true);
                        }}
                        style={{
                          cursor: "pointer",
                          height: "40px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px",
                          backgroundColor: "#20824A",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "14px",
                            fontWeight: "700",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          Close
                        </p>
                      </div>
                    )}
                  {checkAdditionalPermission("Status update") && ticketDetail.status === "Closed" && (
                    <div
                      onClick={() => {
                        setUpdateStatus("Completed");
                        setShowStatusUpdate(true);
                      }}
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.6px solid #E5E5E5",
                        padding: "10px 28px",
                        backgroundColor: "#20824A",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "700",
                          lineHeight: "18.9px",
                          margin: "0",
                          color: "#FFFFFF",
                        }}
                      >
                        Complete
                      </p>
                    </div>
                  )}
                  {checkAdditionalPermission("Status update") && ticketDetail.show_reopen === true && (
                    <div
                      onClick={() => {
                        setUpdateStatus("Reopen");
                        setShowStatusUpdate(true);
                      }}
                      style={{
                        cursor: "pointer",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.6px solid #E5E5E5",
                        padding: "10px 28px",
                        backgroundColor: "#20824A",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "700",
                          lineHeight: "18.9px",
                          margin: "0",
                          color: "#FFFFFF",
                        }}
                      >
                        Re-Open
                      </p>
                    </div>
                  )}
                  {ticketDetail.status === "Open" && ticketDetail.next_approver_id === empId && ticketDetail.approval_status === "Pending" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        onClick={() => {
                          setIsOpenApprove("approve");
                          setIsOpenApproveUpdate(true);
                        }}
                        style={{
                          cursor: "pointer",
                          height: "40px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px 10px 28px",
                          gap: "10px",
                          backgroundColor: "#20824A",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "14px",
                            fontWeight: "700",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          Approve
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          setIsOpenApprove("reject");
                          setIsOpenApproveUpdate(true);
                        }}
                        style={{
                          cursor: "pointer",
                          height: "40px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px 10px 28px",
                          gap: "10px",
                          backgroundColor: "#FF0000",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "14px",
                            fontWeight: "700",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          Reject
                        </p>
                      </div>
                    </div>
                  )}
                  {/* <div style={{height:'44px',gap:'10px',borderRadius:'100px',padding:'10px',gap:'10px',backgroundColor:'#FFFFFF',display:'flex',justifyContent:'center',alignItems:'center',marginLeft:'12px',border:'1px solid #E5E5E5'}}>
                                <div style={{width:'24px',height:'24px', display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <img src={set} style={{margin:'0'}}/>
                                </div>
                            </div> */}
                </div>
              </Col>
            </Row>

            {ticketDetail?.main_ticket && (
              <Row className="ticket-card" style={{ display: "flex", gap: "16px" }}>
                {/* Left Container – Ticket Info */}
                <Col>
                  <Container style={{ padding: 0, backgroundColor: "transparent" }}>
                    <div className="ticket-parent">PARENT TICKET</div>
                    <div className="ticket-number">
                      {ticketDetail?.main_ticket?.code ?? "-"} <span>-</span> <span>{ticketDetail?.main_ticket?.title ?? "-"}</span>
                    </div>
                    <div className="ticket-estimation">
                      Estimation: <span className="bold"> {ticketDetail?.main_ticket?.est ?? "-"}</span> <span className="normal">hrs</span>
                    </div>
                  </Container>
                </Col>

                {/* Right Container – Two small containers side by side */}
                <Col>
                  <Row
                    style={{
                      display: "flex",
                      gap: "6px",
                      marginTop: "24px",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Col xs="auto">
                      <Container
                        className="inner-container-status"
                        style={{
                          backgroundColor:
                            ticketDetail?.main_ticket?.status === "Open"
                              ? "#EFEFEF" // green
                              : ticketDetail?.main_ticket?.status === "In Progress"
                                ? "#D8FFD9" // yellow
                                : ticketDetail?.main_ticket?.status === "Hold"
                                  ? "#FBEFCA" // red
                                  : "#FFEAE9",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "3px",
                              backgroundColor:
                                ticketDetail?.main_ticket?.status === "Open"
                                  ? "#9E9E9E" // green
                                  : ticketDetail?.main_ticket?.status === "In Progress"
                                    ? "#4CAF50" // yellow
                                    : ticketDetail?.main_ticket?.status === "Hold"
                                      ? "#FFC107" // red
                                      : "#F44336",
                            }}
                          ></div>
                          <span className="status-text"> {ticketDetail?.main_ticket?.status ?? "-"}</span>
                        </div>
                      </Container>
                    </Col>
                    <Col xs="auto">
                      <Container
                        className="inner-container"
                        style={{ cursor: "pointer" }}
                        pointer
                        onClick={() => {
                          navigate(`/ticket/view/${ticketDetail?.main_ticket?.id}`, {
                            state: {
                              refresh: Date.now(),
                            },
                          });
                          // navigate("/ticket/view", {
                          //   state: {
                          //     id: ticketDetail?.main_ticket?.id,
                          //     refresh: Date.now(),
                          //   },
                          // });
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span className="status-text-view">View details</span>
                          <ViewDetails />
                        </div>
                      </Container>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}

            <Col
              style={{
                padding: "16px",
                height: "calc(100vh- 159px)",
                overflow: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                justifyContent: "center",
              }}
              xs={12}
              className="maincontent4"
            >
              {/* <div style={{display:'flex',justifyContent:'space-between'}}> */}
              <Row xs={12} className="align-items-stretch">
                <Col sm={12} md={6} lg={7}>
                  <div
                    style={{
                      marginTop: "8px",
                      borderRadius: "16px",
                      padding: "16px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Left side: first two divs */}
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <div
                          style={{
                            maxWidth: "200px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            padding: "6px 16px",
                            backgroundColor: "#EFF3FF",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "satoshi",
                              fontWeight: "500",
                              fontSize: "12.5px",
                              lineHeight: "16.88px",
                              color: "#6929E2",
                            }}
                          >
                            #{ticketDetail.code}
                          </span>
                        </div>
                        {ticketDetail.ticket_from != null && ticketDetail.ticket_from === "Email" && (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                              style={{
                                marginLeft: "8px",
                                marginRight: "8px",
                                width: "4px",
                                height: "4px",
                                borderRadius: "100px",
                                background: "#D9D9D9",
                              }}
                            ></div>{" "}
                            <div
                              style={{
                                padding: "2px 6px",
                                borderRadius: "6px",
                                backgroundColor: "#e3e9e5",
                                height: "max-content",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  color: "#20824A",
                                }}
                              >
                                Mail
                              </div>
                            </div>
                          </div>
                        )}
                        {ticketDetail?.main_ticket && (
                          <div
                            style={{
                              maxWidth: "200px",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "6px",
                              padding: "6px 16px",
                              backgroundColor: "#D9FFE9",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "satoshi",
                                fontWeight: "500",
                                fontSize: "12.5px",
                                lineHeight: "16.88px",
                                color: "#17B65B",
                              }}
                            >
                              Sub ticket
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Right side: stars */}
                      <div>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span key={star} style={{ cursor: "pointer", fontSize: "24px" }}>
                            {star <= (ticketDetail.rating ?? 0) ? <img src={yellowIcon} alt="star" /> : <img src={greyIcon} alt="star" />}
                          </span>
                        ))}
                      </div>
                    </div>

                    {!titleEdit && (
                      <div
                        style={{
                          marginTop: "16px",
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "18px",
                            lineHeight: "24.3px",
                            color: "#212129",
                            flex: 1,
                            minWidth: 0,
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                          }}
                        >
                          {/* sss */}
                          {ticketDetail.title}
                        </span>
                        {checkPermission("edit_permission") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                          <div className="editIcon ms-3" style={{ flexShrink: 0 }} onClick={() => settitleEdit(true)}>
                            <img src={EditIocns} alt="Edit" />
                          </div>
                        )}
                      </div>
                    )}
                    {titleEdit && (
                      <div
                        style={{
                          marginTop: "12px",
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderBottom: "2px solid #6f42c1", // purple line
                          paddingBottom: "4px",
                        }}
                      >
                        <input
                          type="text"
                          value={titleeditValue}
                          onChange={(e) => settitleeditValue(e.target.value)}
                          className="form-control custom-input"
                          style={{
                            flex: 1,
                            fontWeight: "700",
                            fontSize: "16px",
                            marginRight: "10px",
                            border: "none",
                            boxShadow: "none", // removes Bootstrap shadow
                          }}
                        />

                        <div
                          className="removeIcon "
                          style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "100%",
                            backgroundColor: "#FF4444",
                            cursor: "pointer",
                            display: "flex", // center horizontally
                            alignItems: "center", // center vertically
                            justifyContent: "center",
                          }}
                          onClick={() => settitleEdit(false)}
                        >
                          <img
                            src={CloseIocns}
                            alt="close"
                            style={{
                              width: "12px",
                              height: "12px",
                              filter: "brightness(0) invert(1)",
                            }}
                          />
                        </div>
                        <div
                          className="removeIcon ms-2"
                          style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "100%",
                            backgroundColor: "#6929E2",
                            cursor: "pointer",
                            display: "flex", // center horizontally
                            alignItems: "center", // center vertically
                            justifyContent: "center",
                          }}
                          onClick={() => updateTitle()}
                        >
                          <img
                            src={tickIocns}
                            alt="close"
                            style={{
                              width: "12px",
                              height: "12px",
                              filter: "brightness(0) invert(1)",
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {titleEdit && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationstitle.title}
                      </span>
                    )}
                    {/*  <div style={{ marginBottom: "16px" }}>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#8790A1",
                        }}
                      >
                        Created on {ticketDetail.created}
                      </span>
                    </div> */}

                    <div
                      style={{
                        marginBottom: "16px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#212129",
                        }}
                      >
                        Ticket Details
                      </span>

                      {checkPermission("edit_permission") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                        <div className="editIcon ms-3" style={{ cursor: "pointer" }} onClick={() => openticketDetModal()}>
                          <img src={EditIocns} alt="Edit" />
                        </div>
                      )}
                    </div>

                    {isFieldEnabled("Customer") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                          alignItems: "center",
                        }}
                      >
                        <span
                          title={getFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))}
                          style={{
                            flex: "3.5",
                            minWidth: "115px",
                            maxWidth: "45%",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))}
                        </span>
                        <span
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.customer ?? "---"}
                        </span>
                      </div>
                    )}

                    {isFieldEnabled("Vendor") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                          alignItems: "center",
                        }}
                      >
                        <span
                          title={getFieldLabel("Vendor", "Vendor")}
                          style={{
                            flex: "3.5",
                            minWidth: "115px",
                            maxWidth: "45%",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Vendor", "Vendor")}
                        </span>
                        <span
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.vendor ?? "---"}
                        </span>
                      </div>
                    )}

                    {isFieldEnabled("Project") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                          alignItems: "center",
                        }}
                      >
                        <span
                          title={getFieldLabel("Project", "Project")}
                          style={{
                            flex: "3.5",
                            minWidth: "115px",
                            maxWidth: "45%",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Project", "Project")}
                        </span>
                        <span
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.project}
                        </span>
                      </div>
                    )}
                    {isFieldEnabled("Level") &&
                      ticketDetail.levels != undefined &&
                      ticketDetail.levels.map((levelOption, index) => (
                        <div
                          style={{
                            gap: "4px",
                            display: "flex",
                            flex: "10",
                            marginBottom: "12px",
                            alignItems: "center",
                          }}
                        >
                          <span
                            title={`${getFieldLabel("Level", "Level")} ${index + 1}`}
                            style={{
                              flex: "3.5",
                              minWidth: "115px",
                              maxWidth: "45%",
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#8790A1",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getFieldLabel("Level", "Level")} {index + 1}
                          </span>
                          <span
                            style={{
                              flex: "6",
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            {levelOption.label}
                          </span>
                        </div>
                      ))}
                    {/*  <div style={{gap:'4px',display:'flex',flex:'10',marginBottom:'12px'}}>
                                <p style={{flex:'2',fontFamily:'Satoshi',fontWeight:'400',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>Module</p>
                                <p style={{flex:'6',fontFamily:'Satoshi',fontWeight:'500',fontSize:'14px',lineHeight:'18.9px',color:'#212129'}}>{ticketDetail.module}</p>
                            </div>

                            <div style={{gap:'4px',display:'flex',flex:'10',marginBottom:'12px'}}>
                                <p style={{flex:'2',fontFamily:'Satoshi',fontWeight:'400',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>Component</p>
                                <p style={{flex:'6',fontFamily:'Satoshi',fontWeight:'500',fontSize:'14px',lineHeight:'18.9px',color:'#212129'}}>{ticketDetail.component}</p>
                            </div>

                            <div style={{gap:'4px',display:'flex',flex:'10',marginBottom:'12px'}}>
                                <p style={{flex:'2',fontFamily:'Satoshi',fontWeight:'400',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>Sub Component</p>
                                <p style={{flex:'6',fontFamily:'Satoshi',fontWeight:'500',fontSize:'14px',lineHeight:'18.9px',color:'#212129'}}>{ticketDetail.sub_component}</p>
                            </div> */}

                    {isFieldEnabled("Priority") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                          alignItems: "center",
                        }}
                      >
                        <span
                          title={getFieldLabel("Priority", "Priority")}
                          style={{
                            flex: "3.5",
                            minWidth: "115px",
                            maxWidth: "45%",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Priority", "Priority")}
                        </span>
                        <div style={{ display: "flex", flex: "6", alignItems: "center" }}>
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "2px",
                              backgroundColor: getPriorityColor(ticketDetail.priority),
                              marginRight: "4px",
                            }}
                          ></span>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            {ticketDetail.priority}
                          </span>
                        </div>
                      </div>
                    )}
                    <Row xs={12}>
                      <Col sm={6} style={{ paddingLeft: "0px", paddingRight: "4px" }}>
                        <div
                          style={{
                            padding: "16px",
                            borderRadius: "16px",
                            backgroundColor: "#F6F1FF",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "500",
                                fontSize: "13px",
                                color: "#212129",
                              }}
                            >
                              Worked Duration
                            </div>
                            {/* <div
                              style={{
                                padding: "4px 8px",
                                borderRadius: "6px",
                                backgroundColor: "#FFFFFF",
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: "500",
                                  fontSize: "13px",
                                  color: "#20824A",
                                }}
                              >
                                {ticketDetail.status ?? "--:--"}
                              </div>
                            </div> */}
                          </div>
                          <div
                            style={{
                              fontWeight: "900px",
                              fontSize: "14px",
                              color: "#212129",
                            }}
                          >
                            {ticketDetail.status !== "In Progress" && (ticketDetail.syslogged_duration ?? "--:--")}
                            {ticketDetail.status === "In Progress" && ticketDetail.syslogged_duration != null && <Timer key="inprogress-timer" initialSeconds={parseDuration(ticketDetail.syslogged_duration?.split(".")?.[0] || "0")} />}
                          </div>
                        </div>
                      </Col>
                      <Col sm={6} style={{ paddingLeft: "4px", paddingRight: "0px" }}>
                        <div
                          style={{
                            padding: "16px",
                            borderRadius: "16px",
                            backgroundColor: "#F6F1FF",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "500",
                              fontSize: "13px",
                              color: "#212129",
                            }}
                          >
                            Manual Closed Duration
                          </div>

                          <div
                            style={{
                              fontWeight: "900",
                              fontSize: "14px",
                              color: "#212129",
                            }}
                          >
                            {ticketDetail.manlogged_duration ?? "--:--"}{" "}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      marginTop: "8px",
                      borderRadius: "16px",
                      padding: "16px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    {isFieldEnabled("Description") && (
                      <div
                        style={{
                          borderBottom: "1px dotted #E5E5E5",
                          marginBottom: "16px",
                          maxHeight: "400px",
                          overflow: "auto",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            title={getFieldLabel("Description", "Description")}
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "21.6px",
                              color: "#212129",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getFieldLabel("Description", "Description")}
                          </span>

                          {checkPermission("edit_permission") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                            <div className="editIcon ms-3" style={{ cursor: "pointer" }} onClick={() => openticketDetailsModal()}>
                              <img src={EditIocns} alt="Edit" />
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            // width: "300px",
                            borderBottom: "1px #E5E5E5",
                            gap: "24px",
                            paddingBottom: "16px",
                            marginBottom: "16px",
                          }}
                        >
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "15px",
                              lineHeight: "20.25px",
                              color: "#212129",
                            }}
                          >
                            {" "}
                            <pre
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "15px",
                                lineHeight: "20.25px",
                                color: "#212129",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              <HtmlContent html={ticketDetail.description || "N/A"} />

                              {/* {parseHtml(
                              sanitizeDescription(
                                ticketDetail.description ?? ""
                              )
                            )} */}
                            </pre>
                          </p>
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Action Plan") && (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            title={getFieldLabel("Action Plan", "Action Plan")}
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "21.6px",
                              color: "#212129",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getFieldLabel("Action Plan", "Action Plan")}
                          </span>

                          {checkPermission("edit_permission") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                            <div className="editIcon ms-3" style={{ cursor: "pointer" }} onClick={() => openticketDetailsModal()}>
                              <img src={EditIocns} alt="Edit" />
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            borderBottom: "1px #E5E5E5",
                            gap: "24px",
                            paddingBottom: "16px",
                            marginBottom: "16px",
                          }}
                        >
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "15px",
                              lineHeight: "20.25px",
                              color: "#212129",
                            }}
                          >
                            <pre
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "15px",
                                lineHeight: "20.25px",
                                color: "#212129",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              <HtmlContent html={ticketDetail.action_plan || "N/A"} />
                            </pre>
                          </p>
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Action Taken") && ticketDetail.action_taken && (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            title={getFieldLabel("Action Taken", "Action Taken")}
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              lineHeight: "21.6px",
                              color: "#212129",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getFieldLabel("Action Taken", "Action Taken")}
                          </span>
                        </div>
                        <div
                          style={{
                            borderBottom: "1px #E5E5E5",
                            gap: "24px",
                            paddingBottom: "16px",
                            marginBottom: "16px",
                          }}
                        >
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "15px",
                              lineHeight: "20.25px",
                              color: "#212129",
                            }}
                          >
                            <pre
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "15px",
                                lineHeight: "20.25px",
                                color: "#212129",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              <HtmlContent html={ticketDetail.action_taken || "N/A"} />
                            </pre>
                          </p>
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Attachment") && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <span
                            title={`${getFieldLabel("Attachment", "Attachment")} : ${attachmentList.length}`}
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "16px",
                              color: "#212129",
                              display: "inline-block",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getFieldLabel("Attachment", "Attachment")} : {attachmentList.length}
                          </span>
                        </div>
                        <div>
                          <div>
                            {checkAdditionalPermission("Add attachment") && ticketDetail.status !== "Merged" && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && (
                              <div>
                                <div onClick={handleFileClick}>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      fontFamily: "Satoshi",
                                      fontSize: "13px",
                                      fontWeight: "700",
                                      color: "#6929E2",
                                    }}
                                  >
                                    + Add Attachment
                                  </span>
                                </div>
                                <input ref={fileInputRef} type="file" accept=".jpg, .jpeg, .png,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/pdf" style={{ display: "none" }} onChange={handleFileChange} />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Attachment") && attachmentList.length > 0 && (
                      <div
                        style={{
                          marginTop: "16px",
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "flex-start",
                          gap: "16px",
                        }}
                      >
                        {attachmentList.map((item, attachIndex) => (
                          <div
                            onClick={(e) => {
                              if (e.target.closest('[data-no-preview="true"]')) {
                                return;
                              }
                              openImagePreview(item);
                            }}
                            style={{
                              width: "240px",
                              height: "62px",
                              borderRadius: "12px",
                              padding: "10px 12px 10px 12px",
                              backgroundColor: "#F7F7F7",
                              display: "flex",
                              alignItems: "center",
                              cursor: isImageAttachment(item) ? "pointer" : "default",
                            }}
                          >
                            <img src={getAttachmentIcon(item)} style={{ width: "37px", height: "36px" }} />
                            <div
                              style={{
                                width: "240px",
                                marginLeft: "8px",
                                marginTop: "4px",
                              }}
                            >
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "2px",
                                  display: "inline-block",
                                  maxWidth: "150px", // set a max width
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  verticalAlign: "middle",
                                }}
                                title={item.name} // tooltip on hover
                              >
                                {item.name}
                              </span>

                              <br />
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "11px",
                                  lineHeight: "16.2px",
                                  color: "#8790A1",
                                }}
                              >
                                {item.size}
                              </p>
                            </div>

                            {item.url && (
                              <div
                                data-no-preview="true"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadFile(item.url, item.name);
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                }}
                              >
                                <img
                                  src={download}
                                  style={{
                                    width: "12.8px",
                                    height: "12px",
                                    top: "10px",
                                    left: "9.6px",
                                  }}
                                />
                              </div>
                            )}

                            <div
                              data-no-preview="true"
                              style={{
                                position: "relative",
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                                marginLeft: "4px",
                              }}
                            >
                              {checkAdditionalPermission("Add attachment") && ticketDetail.status !== "Merged" && (
                                <img
                                  data-no-preview="true"
                                  src={set}
                                  style={{
                                    width: "12.8px",
                                    height: "12px",
                                    top: "10px",
                                    left: "9.6px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setAlertIndex(attachIndex === alertIndex ? null : attachIndex);
                                  }}
                                />
                              )}
                              {alertIndex === attachIndex && (
                                <div
                                  data-no-preview="true"
                                  ref={alertRef}
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    position: "absolute",
                                    top: "40px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "#ffffff",
                                    color: "#1E1E1E",
                                    padding: "16px",
                                    borderRadius: "16px",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    zIndex: 1,
                                    alignItems: "end",
                                  }}
                                >
                                  <div
                                    data-no-preview="true"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeAttachment(item.id);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      width: "150px",
                                      height: "36px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      color: "#1E1E1E",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "start",
                                    }}
                                  >
                                    Delete
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm={12} md={6} lg={5}>
                  <div
                    style={{
                      marginTop: "8px",
                      borderRadius: "16px",
                      padding: "16px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "16px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#212129",
                        }}
                      >
                        Other Details
                      </span>

                      {checkPermission("edit_permission") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                        <div className="editIcon ms-3" style={{ cursor: "pointer" }} onClick={() => openticketOtherDetModal()}>
                          <img src={EditIocns} alt="Edit" />
                        </div>
                      )}
                    </div>

                    {isFieldEnabled("Estimation") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                        }}
                      >
                        <span
                          title={getFieldLabel("Estimation", "Estimation")}
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Estimation", "Estimation")}
                        </span>
                        <span
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.est ?? "--:--"} hrs
                        </span>
                      </div>
                    )}

                    {isFieldEnabled("Assign To") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          title={getFieldLabel("Assign To", "Assigned To")}
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            marginTop: "0px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Assign To", "Assigned To")}
                        </span>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flex: "6",
                          }}
                        >
                          <img
                            src={ticketDetail.assignee_img != null && ticketDetail.assignee_img !== "" ? ticketDetail.assignee_img : UserImg}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = UserImg;
                            }}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "8px",
                              borderRadius: "100px",
                            }}
                          />
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                              marginTop: "0px",
                            }}
                          >
                            {ticketDetail.assignee}
                          </span>
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Reporter") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          alignItems: "center",
                          flex: "10",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          title={getFieldLabel("Reporter", "Reporter")}
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            marginTop: "5px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Reporter", "Reporter")}
                        </span>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flex: "6",
                          }}
                        >
                          <img
                            src={ticketDetail.reporter_img != null && ticketDetail.reporter_img !== "" ? ticketDetail.reporter_img : UserImg}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = UserImg;
                            }}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "8px",
                              borderRadius: "100px",
                            }}
                          />
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                              marginTop: "0px",
                            }}
                          >
                            {ticketDetail.reporter}
                          </span>
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Reporter") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                          }}
                        >
                          Email Id
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.reporter_email}
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Team") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          title={getFieldLabel("Team", "Team")}
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Team", "Team")}
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.team}
                        </div>
                      </div>
                    )}

                    <div
                      style={{
                        gap: "4px",
                        display: "flex",
                        flex: "10",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          flex: "2",
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#8790A1",
                        }}
                      >
                        System Created Date
                      </div>
                      <div
                        style={{
                          flex: "6",
                          fontFamily: "Satoshi",
                          fontWeight: "500",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#212129",
                        }}
                      >
                        {ticketDetail.system_created}
                      </div>
                    </div>
                    {isFieldEnabled("Create Date") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          title={getFieldLabel("Create Date", "Manual Created Date")}
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Create Date", "Manual Created Date")}
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.manual_created}
                        </div>
                      </div>
                    )}

                    {isFieldEnabled("Expected Date") && (
                      <div
                        style={{
                          gap: "4px",
                          display: "flex",
                          flex: "10",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          title={getFieldLabel("Expected Date", "Expected Date")}
                          style={{
                            flex: "2",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getFieldLabel("Expected Date", "Expected Date")}
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.expected}
                        </div>
                      </div>
                    )}

                    <div
                      style={{
                        padding: "12px",
                        borderRadius: "16px",
                        border: "1px dotted #D3BCFF",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            flex: "4",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                          }}
                        >
                          Start Date & Time
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.start_date}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <div
                          style={{
                            flex: "4",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                          }}
                        >
                          System Closed Date & Time
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.system_closed_date}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "8px",
                        }}
                      >
                        <div
                          style={{
                            flex: "4",
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#8790A1",
                          }}
                        >
                          Manual Closed Date
                        </div>
                        <div
                          style={{
                            flex: "6",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.manual_closed_date}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* More Information: fields NOT enabled in the configuration are
                      hidden from their normal slots above. Show their saved values
                      here (read-only) so nothing configured-off is lost on view. */}
                  {(() => {
                    const moreInfoFields = [
                      { name: "Project", label: getFieldLabel("Project", "Project"), value: ticketDetail.project },
                      { name: "Priority", label: getFieldLabel("Priority", "Priority"), value: ticketDetail.priority },
                      { name: "Estimation", label: getFieldLabel("Estimation", "Estimation"), value: ticketDetail.est != null && ticketDetail.est !== "" ? `${ticketDetail.est} hrs` : "" },
                      { name: "Assign To", label: getFieldLabel("Assign To", "Assigned To"), value: ticketDetail.assignee },
                      { name: "Reporter", label: getFieldLabel("Reporter", "Email Id"), value: ticketDetail.reporter_email },
                      { name: "Team", label: getFieldLabel("Team", "Team"), value: ticketDetail.team },
                      { name: "Create Date", label: getFieldLabel("Create Date", "Manual Created Date"), value: ticketDetail.manual_created },
                      { name: "Expected Date", label: getFieldLabel("Expected Date", "Expected Date"), value: ticketDetail.expected },
                      { name: "Customer", label: getFieldLabel("Customer", getFieldLabel("Client Name", "Customer")), value: ticketDetail.customer },
                      { name: "Vendor", label: getFieldLabel("Vendor", "Vendor"), value: ticketDetail.vendor },
                      { name: "Reference", label: getFieldLabel("Reference", "Reference"), value: ticketDetail.reference },
                    ].filter((f) => !isFieldEnabled(f.name) && f.value != null && f.value !== "");

                    const levelsHidden = !isFieldEnabled("Level") && Array.isArray(ticketDetail.levels) && ticketDetail.levels.length > 0;

                    if (moreInfoFields.length === 0 && !levelsHidden) return null;

                    return (
                      <div
                        style={{
                          marginTop: "8px",
                          borderRadius: "16px",
                          padding: "24px",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "21.6px",
                            color: "#212129",
                            marginBottom: "16px",
                          }}
                        >
                          More Information
                        </p>
                        {moreInfoFields.map((f, i) => (
                          <div
                            key={i}
                            style={{
                              gap: "4px",
                              display: "flex",
                              flex: "10",
                              marginBottom: "12px",
                              alignItems: "center",
                            }}
                          >
                            <span
                              title={f.label}
                              style={{
                                flex: "2",
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#8790A1",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {f.label}
                            </span>
                            <span
                              style={{
                                flex: "6",
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "14px",
                                lineHeight: "18.9px",
                                color: "#212129",
                              }}
                            >
                              {f.value}
                            </span>
                          </div>
                        ))}
                        {levelsHidden &&
                          ticketDetail.levels.map((levelOption, index) => (
                            <div
                              key={`level-${index}`}
                              style={{
                                gap: "4px",
                                display: "flex",
                                flex: "10",
                                marginBottom: "12px",
                                alignItems: "center",
                              }}
                            >
                              <span
                                title={`${getFieldLabel("Level", "Level")} ${index + 1}`}
                                style={{
                                  flex: "2",
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "17.55px",
                                  color: "#8790A1",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {getFieldLabel("Level", "Level")} {index + 1}
                              </span>
                              <span
                                style={{
                                  flex: "6",
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "14px",
                                  lineHeight: "18.9px",
                                  color: "#212129",
                                }}
                              >
                                {levelOption.label}
                              </span>
                            </div>
                          ))}
                      </div>
                    );
                  })()}
                  {/* {
                    <div className="billingCard ">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "21.6px",
                            color: "#212129",
                          }}
                        >
                          Billing details
                        </span>

                        {checkPermission("edit_permission") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                          <div className="editIcon ms-3" style={{ cursor: "pointer" }} onClick={() => openBillingDetailsModal()}>
                            <img src={EditIocns} alt="Edit" />
                          </div>
                        )}
                      </div>
                      {ticketDetail.is_billable != null && ticketDetail.is_billable === true && (
                        <>
                          <Row className="g-3 mt-2">
                            {isFieldEnabled("Customer") && (
                              <Col sm={12}>
                                <div className="customer-card">
                                  <div className="customer-label">Customer</div>
                                  <div className="customer-content">
                                    <div className="customer-avatar"> {ticketDetail?.customer?.charAt(0).toUpperCase() ?? "-"}</div>
                                    <div className="customer-name">{ticketDetail.customer ?? "---"}</div>
                                  </div>
                                </div>
                              </Col>
                            )}
                            {isFieldEnabled("Vendor") && (
                              <Col sm={12}>
                                <div className="customer-card">
                                  <div className="customer-label">Vendor</div>
                                  <div className="customer-content">
                                    <div className="customer-avatar"> {ticketDetail?.vendor?.charAt(0).toUpperCase() ?? "-"}</div>
                                    <div className="customer-name">{ticketDetail.vendor ?? "---"}</div>
                                  </div>
                                </div>
                              </Col>
                            )}
                          </Row>
                          <Row className="g-3 mt-1">
                            {isFieldEnabled("Reference") && (
                              <Col sm={12}>
                                <div className="customer-card">
                                  <div className="customer-label">Reference</div>
                                  <div className="customer-content">
                                    <div className="customer-name">{ticketDetail.reference ?? "---"}</div>
                                  </div>
                                </div>
                              </Col>
                            )}
                          </Row>
                        </>
                      )}
                    </div>
                  } */}
                  <div
                    style={{
                      marginTop: "8px",
                      borderRadius: "16px",
                      padding: "24px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "16px",
                          lineHeight: "21.6px",
                          color: "#212129",
                          marginBottom: "24px",
                        }}
                      >
                        Workflow History : {workflowList.length}
                      </p>
                    </div>
                    {workflowList.length > 0 &&
                      workflowList.map((workflow, wIndex) => (
                        <div style={{ display: "flex" }}>
                          <div style={{ paddingTop: "10px", gap: "3px" }}>
                            <div style={{ width: "32px", height: "32px" }}>
                              <div
                                style={{
                                  width: "31.33px",
                                  height: "31.33px",
                                  top: "0.34px",
                                  left: "0.34px",
                                  borderRadius: "100px",
                                  opacity: "40px",
                                  backgroundColor: "#ACB9FF",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img src={getStatusIcon(workflow.status)} style={{ margin: "0" }} alt="status" />
                              </div>
                            </div>
                            {workflowList.length - 1 !== wIndex && (
                              <div
                                style={{
                                  height: "64px",
                                  borderLeft: "1px dashed #6929E2",
                                  marginLeft: "14px",
                                }}
                              ></div>
                            )}
                          </div>

                          <div style={{ gap: "24px", marginLeft: "16px" }}>
                            <div>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "18.9px",
                                  color: "#212129",
                                }}
                              >
                                {workflow.status}
                              </span>
                            </div>
                            <div>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                }}
                              >
                                {workflow.description}
                              </span>
                            </div>

                            <div>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "12px",
                                  lineHeight: "16.2px",
                                  color: "#8790A1",
                                }}
                              >
                                {workflow.date}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Col>
              </Row>

              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  marginTop: "16px",
                }}
              >
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >
                      <div
                        onClick={() => {
                          setTabView("Comments");
                        }}
                        style={{
                          cursor: "pointer",
                          width: "90px",
                          height: "36px",
                          borderRadius: "12px",
                          background: tabView === "Comments" ? "#F5F0FF" : "#F8F8F8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: tabView === "Comments" ? "700" : "500",
                            fontSize: "13px",
                            color: tabView === "Comments" ? "#6929E2" : "#212129",
                          }}
                        >
                          Comments
                        </span>
                      </div>
                      {!ticketDetail.is_sub && !ticketDetail.main_ticketid && !ticketDetail.main_ticket && (
                        <div
                          onClick={() => {
                            setTabView("Sub Ticket");
                          }}
                          style={{
                            cursor: "pointer",
                            width: "88px",
                            height: "36px",
                            borderRadius: "12px",
                            background: tabView === "Sub Ticket" ? "#F5F0FF" : "#F8F8F8",
                            marginLeft: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: tabView === "Sub Ticket" ? "700" : "500",
                              fontSize: "13px",
                              color: tabView === "Sub Ticket" ? "#6929E2" : "#212129",
                            }}
                          >
                            Sub Tickets
                          </span>
                        </div>
                      )}
                      <div
                        onClick={() => {
                          setTabView("Edit history");
                          getEditHistory();
                        }}
                        style={{
                          cursor: "pointer",
                          width: "88px",
                          height: "36px",
                          borderRadius: "12px",
                          background: tabView === "Edit history" ? "#F5F0FF" : "#F8F8F8",
                          marginLeft: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: tabView === "Edit history" ? "700" : "500",
                            fontSize: "13px",
                            color: tabView === "Edit history" ? "#6929E2" : "#212129",
                          }}
                        >
                          History
                        </span>
                      </div>
                      {ticketDetail?.merged_tickets?.length > 0 && (
                        <div
                          onClick={() => {
                            setTabView("Merged Tickets");
                          }}
                          style={{
                            cursor: "pointer",
                            width: "120px",
                            height: "36px",
                            borderRadius: "12px",
                            background: tabView === "Merged Tickets" ? "#F5F0FF" : "#F8F8F8",
                            marginLeft: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: tabView === "Merged Tickets" ? "700" : "500",
                              fontSize: "13px",
                              color: tabView === "Merged Tickets" ? "#6929E2" : "#212129",
                            }}
                          >
                            Merged Tickets
                          </span>
                        </div>
                      )}
                    </div>
                    {checkAdditionalPermission("Add comment") && tabView === "Comments" && ticketDetail.status !== "Merged" && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && (
                      <div
                        onClick={() => {
                          setIsOpenComment(true);
                        }}
                      >
                        <div
                          style={{
                            cursor: "pointer",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            border: "0.8px solid #DCDFE4",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              fontWeight: "700",
                              color: "#6929E2",
                            }}
                          >
                            + Add Comment
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {tabView === "Comments" &&
                    commentsList.map((comment) => (
                      <div
                        style={{
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          borderBottom: "0.5px solid #D4DDE7",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                        >
                          <img
                            src={comment.image != null && comment.image !== "" ? comment.image : UserImg}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = UserImg;
                            }}
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "100px",
                            }}
                            alt="comment user"
                          />
                          <span
                            style={{
                              marginLeft: "8px",
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#212129",
                            }}
                          >
                            {comment.name}
                          </span>
                          <div
                            style={{
                              marginLeft: "8px",
                              marginRight: "8px",
                              width: "4px",
                              height: "4px",
                              borderRadius: "100px",
                              background: "#D9D9D9",
                            }}
                          ></div>
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "500",
                              color: "#98A1B0",
                            }}
                          >
                            {comment.date}
                          </span>

                          {comment.comment_from != null && comment.comment_from === "Email" && (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div
                                style={{
                                  marginLeft: "8px",
                                  marginRight: "8px",
                                  width: "4px",
                                  height: "4px",
                                  borderRadius: "100px",
                                  background: "#D9D9D9",
                                }}
                              ></div>
                              <div
                                style={{
                                  padding: "2px 6px",
                                  borderRadius: "6px",
                                  backgroundColor: "#e3e9e5",
                                  height: "max-content",
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#20824A",
                                  }}
                                >
                                  Mail
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <span
                          style={{
                            paddingTop: "16px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#212129",
                          }}
                        >
                          <pre
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              maxHeight: "150px",
                              overflow: "auto",
                              fontSize: "15px",
                              lineHeight: "20.25px",
                              color: "#212129",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {" "}
                            <HtmlContent html={comment.comment || "N/A"} />
                            {/* {parseHtml(
                              (comment.comment ?? "").replace(/\\r\\n/g, "")
                            )} */}
                          </pre>
                        </span>
                      </div>
                    ))}
                  {tabView === "Comments" && commentsList.length > 0 && totalCommentCount > commentsList.length && (
                    <button
                      style={{
                        height: "44px",
                        color: "#FFFFFF",
                        gap: "8px",
                        backgroundColor: "#FFFFFF",
                        marginLeft: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textDecoration: "none",
                        border: "none",
                      }}
                      onClick={() => getCommentsList("seeMore")}
                    >
                      <p style={{ margin: "0", color: "#6929E2" }}>Load more...</p>
                    </button>
                  )}
                </>

                {tabView === "Comments" && commentsList.length === 0 && (
                  <>
                    <div
                      style={{
                        width: "419px",
                        gap: "24px",
                        marginBottom: "32px",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "16px",
                          lineHeight: "21.6px",
                          color: "#212129",
                        }}
                      >
                        Comments
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          height: "114px",
                          width: "265px",
                          gap: "16px",
                          margin: "0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <img
                            src={note}
                            style={{
                              width: "80px",
                              height: "80px",
                              opacity: "70px",
                              marginBottom: "16px",
                              margin: "0",
                            }}
                          />
                        </div>
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          {ticketDetail.status === "Closed" || ticketDetail.status === "Completed"
                            ? "No comments available"
                            : "Add your comments by clicking below button"}
                        </p>
                      </div>
                    </div>

                    {checkAdditionalPermission("Add comment") && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && ticketDetail.status !== "Merged" && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <div
                          onClick={() => {
                            setIsOpenComment(true);
                          }}
                          style={{
                            cursor: "pointer",
                            margin: "0",
                            height: "36px",
                            borderRadius: "8px",
                            padding: "10px 16px 10px 16px",
                            gap: "8px",
                            backgroundColor: "#EBEEFF",
                          }}
                        >
                          <p
                            style={{
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              fontWeight: "700",
                              color: "#212129",
                            }}
                          >
                            + Add Comment
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {tabView === "Comments" && isOpenComment && (
                  <div style={commentModalStyle.overlay}>
                    <div style={commentModalStyle.modal}>
                      <div style={{ color: "#ffffff" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            <div
                              style={{
                                paddingLeft: "4px",
                                fontSize: "20px",
                                fontWeight: "500",
                                color: "#212129",
                              }}
                            >
                              Add your comments
                            </div>
                            <div
                              style={{
                                paddingLeft: "4px",
                                fontSize: "20px",
                                fontWeight: "400",
                                color: "#98A1B0",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                              }}
                            >
                              {ticketDetail.title ?? ""}
                            </div>
                          </div>
                          <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeCommentModal} />
                        </div>

                        <div style={{ marginTop: "8px" }}>
                          <div>
                            <div>
                              <textarea
                                type="text"
                                placeholder=" "
                                className="form-control"
                                value={descriptionInputValue}
                                rows={6}
                                onChange={(event) => {
                                  setDescriptionInputValue(event.target.value); // Update state with input value
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.description}
                              </span>
                            </div>
                          </div>
                          <Row
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "end",
                              marginTop: "8px",
                            }}
                          >
                            <div
                              onClick={(e) => {
                                closeCommentModal();
                              }}
                              style={{
                                cursor: "pointer",
                                width: "176px",
                                height: "44px",
                                marginLeft: "8px",
                                marginRight: "8px",
                                borderRadius: "100px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#FFFFFF",
                                border: "0.6px solid #E5E5E5",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  color: "#1E1E1E",
                                }}
                              >
                                Cancel
                              </div>
                            </div>
                            <div
                              onClick={(e) => {
                                if (loading === false) {
                                  saveComment();
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                width: "176px",
                                height: "44px",
                                marginLeft: "8px",
                                marginRight: "8px",
                                borderRadius: "100px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#3253EB",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  color: "#FFFFFF",
                                }}
                              >
                                Add
                              </div>
                            </div>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {tabView === "Sub Ticket" && (
                  <>
                    <Row style={{ marginTop: "16px" }}>
                      <Col sm={12} md={4} lg={3}>
                        <div
                          style={{
                            padding: "8px 8px",
                            borderRadius: "10px",
                            border: "0.5px solid #DCDFE4",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "8px",
                              background: "#F7F8F9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img src={totalEstIcon} style={{ margin: "0" }} alt="Total Est" />
                          </div>
                          <div style={{ marginLeft: "8px", minWidth: 0, flex: 1 }}>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "17.55px",
                                color: "#626F86",
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Total estimation
                            </span>
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "14px",
                                color: "#172B4D",
                              }}
                            >
                              {subTicketTotalEst ?? "00:00"} hrs
                            </div>
                          </div>
                        </div>{" "}
                      </Col>

                      {subTicketEstList.map((item, index) => (
                        <Col sm={12} md={4} lg={3}>
                          <div
                            style={{
                              padding: "8px 8px",
                              borderRadius: "10px",
                              border: "0.5px solid #DCDFE4",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "8px",
                                background: "#F7F8F9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img src={totalEstIcon} style={{ margin: "0" }} alt="Total Est" />
                            </div>
                            <div style={{ marginLeft: "8px", minWidth: 0, flex: 1 }}>
                              <span
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  lineHeight: "17.55px",
                                  color: "#626F86",
                                  display: "block",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.name ?? ""}
                              </span>
                              <div
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  color: "#172B4D",
                                }}
                              >
                                {item.est ?? "00:00"} hrs
                              </div>
                            </div>
                          </div>{" "}
                        </Col>
                      ))}
                      {/* <Col sm={12} md={6} lg={3}> 
  <div style={{ padding:'8px 8px', borderRadius:'10px', border:'0.5px solid #DCDFE4', display:'flex', alignItems:'center', justifyContent:'start' }}>
  <div style={{width:'40px', height:'40px',borderRadius:'8px', background:'#F7F8F9',display:'flex', alignItems:'center', justifyContent:'center' }}>
    <img src={developmentIcon} style={{margin:'0'}} alt="Development"/>
    </div>
  <div style={{marginLeft:'8px',}}>
  <span style={{fontFamily:'Satoshi',fontWeight:'400',fontSize:'14px',lineHeight:'17.55px',color:'#626F86',}}>Development</span>
  <div style={{fontFamily:'Satoshi',fontWeight:'700',fontSize:'14px',color:'#172B4D'}}>00:00 hrs</div>
  </div>
    </div>
    </Col>
  <Col sm={12} md={6} lg={3}>
  <div style={{ padding:'8px 8px', borderRadius:'10px', border:'0.5px solid #DCDFE4', display:'flex', alignItems:'center', justifyContent:'start' }}>
  <div style={{width:'40px', height:'40px',borderRadius:'8px', background:'#F7F8F9',display:'flex', alignItems:'center', justifyContent:'center' }}>
    <img src={designIcon} style={{margin:'0'}} alt="Design"/>
    </div>
  <div style={{marginLeft:'8px',}}>
  <span style={{fontFamily:'Satoshi',fontWeight:'400',fontSize:'14px',lineHeight:'17.55px',color:'#626F86',}}>Design</span>
  <div style={{fontFamily:'Satoshi',fontWeight:'700',fontSize:'14px',color:'#172B4D'}}>00:00 hrs</div>
  </div>
    </div>
   </Col>
  <Col sm={12} md={6} lg={3}>
  <div style={{ padding:'8px 8px', borderRadius:'10px', border:'0.5px solid #DCDFE4', display:'flex', alignItems:'center', justifyContent:'start' }}>
  <div style={{width:'40px', height:'40px',borderRadius:'8px', background:'#F7F8F9',display:'flex', alignItems:'center', justifyContent:'center' }}>
    <img src={testingIcon} style={{margin:'0'}} alt="Testing"/>
    </div>
  <div style={{marginLeft:'8px',}}>
  <span style={{fontFamily:'Satoshi',fontWeight:'400',fontSize:'14px',lineHeight:'17.55px',color:'#626F86',}}>Testing</span>
  <div style={{fontFamily:'Satoshi',fontWeight:'700',fontSize:'14px',color:'#172B4D'}}>00:00 hrs</div>
  </div>
    </div>
     </Col> */}
                    </Row>
                    <Row style={{ marginBottom: "16px" }}>
                      <Col sm={12} lg={7} className=" mt-2">
                        <div className="part13 d-flex ">
                          <div onClick={() => setListingType("All")} className={listingType === "All" ? "sub-tckt-act-box" : "sub-tckt-inact-box"}>
                            <div className={listingType === "All" ? "sub-tckt-act-txt" : "sub-tckt-inact-txt"}> All {listingType === "All" && totalCount} </div>
                          </div>

                          <div onClick={() => setListingType("Open")} className={listingType === "Open" ? "sub-tckt-act-box" : "sub-tckt-inact-box"}>
                            <p className={listingType === "Open" ? "sub-tckt-act-txt" : "sub-tckt-inact-txt"}>Open {listingType === "Open" && totalCount}</p>
                          </div>

                          <div onClick={() => setListingType("In-Progress")} className={listingType === "In-Progress" ? "sub-tckt-act-box" : "sub-tckt-inact-box"}>
                            <p className={listingType === "In-Progress" ? "sub-tckt-act-txt" : "sub-tckt-inact-txt"}>In Progress {listingType === "In-Progress" && totalCount}</p>
                          </div>

                          <div onClick={() => setListingType("Hold")} className={listingType === "Hold" ? "sub-tckt-act-box" : "sub-tckt-inact-box"}>
                            <p className={listingType === "Hold" ? "sub-tckt-act-txt" : "sub-tckt-inact-txt"}>Hold {listingType === "Hold" && totalCount}</p>
                          </div>

                          <div onClick={() => setListingType("Closed")} className={listingType === "Closed" ? "sub-tckt-act-box" : "sub-tckt-inact-box"}>
                            <p className={listingType === "Closed" ? "sub-tckt-act-txt" : "sub-tckt-inact-txt"}>Closed {listingType === "Closed" && totalCount}</p>
                          </div>

                          <div onClick={() => setListingType("Completed")} className={listingType === "Completed" ? "sub-tckt-act-box" : "sub-tckt-inact-box"}>
                            <p className={listingType === "Completed" ? "sub-tckt-act-txt" : "sub-tckt-inact-txt"}>Completed {listingType === "Completed" && totalCount}</p>
                          </div>
                        </div>
                      </Col>
                      <Col sm={12} lg={5} className="d-flex justify-content-end mt-2">
                        <div className="part23 d-flex justify-content-xl-end mt-lg-0" style={{ height: "36px" }}>
                          <input
                            type="text"
                            placeholder="Search.."
                            className="txt3 mx-3"
                            onChange={(event) => {
                              handleSearch(event.target.value);
                            }}
                          />

                          {ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && !ticketDetail.is_sub && !ticketDetail.main_ticketid && !ticketDetail.main_ticket && (
                            <div
                              className="daddtask3 px-2"
                              style={{ cursor: "pointer", height: "36px" }}
                              onClick={() => {
                                navigate("/ticket/add", {
                                  state: { parentTicketId: id },
                                });
                              }}
                            >
                              <p className="paddtask3" style={{ fontSize: "12px" }}>
                                +Create Sub Ticket
                              </p>
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                    {inProgressList.map((item, index) => (
                      <div key={"in-pro" + index} className="sub-tckt-inprog d-flex justify-content-between">
                        <div>
                          <div className="taslog3">
                            <span className="tas3">{item.title}</span>
                            <img
                              src={subTicketIcon}
                              style={{
                                width: "16px",
                                height: "16px",
                                marginLeft: "8px",
                                marginTop: "-5px",
                              }}
                            />
                          </div>
                          <div className="d-flex lst3">
                            <div className="est3">Estimation :</div>
                            <div className="tim3">{item.est ?? "00:00"} </div>
                          </div>
                        </div>

                        <div>
                          <div className="d-flex part333">
                            <div className="d-flex part33" style={{ backgroundColor: "#FFFFFF" }}>
                              <img src={rectangle} className="rect3" alt="inprogress" />
                              <div className="inp3">InProgress</div>
                              <div className="on3">|</div>
                              {/*  { formatTime(inProgressList[index].seconds_elapsed!=undefined?inProgressList[index].seconds_elapsed:10)} */}
                              <div className="timm3">{item.duration != null && <Timer key={"inprogress-timer" + item.id} initialSeconds={parseDuration(item.duration.split(".")[0]) + Math.floor((new Date() - new Date(item.fetchedAt)) / 1000)} />}</div>
                            </div>

                            <div
                              style={{
                                width: "1px",
                                /* height: "75px", */
                                backgroundColor: "#E5E5E5",
                                marginLeft: "16px",
                              }}
                            ></div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {/* <Link to="/ticket/view" state={{ id: item.id,}} className="link23">
                  <div style={{fontFamily: 'Satoshi',fontSize:'14px', fontWeight:'500', color:'#6929E2',marginRight:'8px'}}>View details</div>
                </Link>
                <Link to="/ticket/view" state={{ id: item.id,}} className="link23">
                  <img src={arrows} className="arrows3" />
                </Link> */}
                              {item.status === "In Progress" && (
                                <div
                                  onClick={() => {
                                    setSubTicketDetails(item);
                                    setIsOpenHold(true);
                                    setIsOpenStatusUpdate(true);
                                    setExpectedDate(moment(new Date()).format("YYYY-MM-DD"));
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    height: "40px",
                                    borderRadius: "100px",
                                    border: "1px solid #6929E2",
                                    padding: "10px 28px 10px 28px",
                                    gap: "10px",
                                    backgroundColor: "#FFFFFF",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                      lineHeight: "18.9px",
                                      margin: "0",
                                      color: "#6929E2",
                                    }}
                                  >
                                    Hold
                                  </p>
                                </div>
                              )}
                              {(item.status === "In Progress" || item.status === "Hold") && (
                                <div
                                  onClick={() => {
                                    setSubTicketDetails(item);
                                    setIsOpenClose(true);
                                    setIsOpenStatusUpdate(true);
                                    setClosingDate(moment(new Date()).format("YYYY-MM-DD"));
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "8px",
                                    height: "40px",
                                    borderRadius: "100px",
                                    border: "0.6px solid #E5E5E5",
                                    padding: "10px 28px 10px 28px",
                                    gap: "10px",
                                    backgroundColor: "#6929E2",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                      lineHeight: "18.9px",
                                      margin: "0",
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    Close
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div /* className="fourth3" */>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flex: "10",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            borderLeft: "3px solid transparent",
                          }}
                          className="head3"
                        >
                          <p style={{ minWidth: "70px", flex: "1" }} className="p3">
                            Code
                          </p>
                          <p style={{ minWidth: "150px", flex: "2" }} className="p3">
                            Title
                          </p>
                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Project
                          </p>
                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Level 1
                          </p>
                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Assigned to
                          </p>
                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Reporter
                          </p>

                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Created Date
                          </p>

                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Expected Date
                          </p>
                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Estimation
                          </p>
                          <p style={{ minWidth: "100px", flex: "1" }} className="p3">
                            Status
                          </p>
                        </div>

                        <div>
                          {subTicketList.map((item, index) => (
                            <div
                              key={"table-list" + index}
                              style={{
                                position: "relative",
                              }} /* onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)} */
                            >
                              {/*  <Link to="/ticket/view" state={{ id: item.id,}} className="link23"> */}
                              <div
                                onClick={() => {
                                  // navigate("/ticket/view", {
                                  //   state: { id: item.id },
                                  // });
                                  navigate(`/ticket/view/${item.id}`);
                                  navigate(0);
                                }}
                                style={{
                                  cursor: "pointer",
                                  paddingLeft: "16px",
                                  paddingRight: "16px",
                                  display: "flex",
                                  borderLeft: "3px solid transparent",
                                }}
                                className="body3"
                              >
                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "70px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.code}
                                >
                                  {item.code}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "150px",
                                    flex: "2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.title}
                                >
                                  {item.title}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.project}
                                >
                                  {item.project}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.component ?? ""}
                                >
                                  {item.component ?? ""}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.assigned_to ?? ""}
                                >
                                  {item.assigned_to ?? ""}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.reporter ?? ""}
                                >
                                  {item.reporter ?? ""}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.c_date || item.created || item.created_date || ""}
                                >
                                  {item.c_date || item.created || item.created_date || "-"}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.date || item.expected || item.expected_date || item.e_date || item.exp_date || ""}
                                >
                                  {item.date || item.expected || item.expected_date || item.e_date || item.exp_date || "-"}
                                </p>

                                <p
                                  className="p13"
                                  style={{
                                    minWidth: "100px",
                                    flex: "1",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                  title={item.est}
                                >
                                  {item.est}
                                </p>

                                <div style={{ minWidth: "100px", flex: "1" }} className="style-justify-start">
                                  <span
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "4px", // make it slightly rounded, or remove for sharp

                                      backgroundColor:
                                        item.status === "Open"
                                          ? "#9E9E9E" // green
                                          : item.status === "In Progress"
                                            ? "#4CAF50" // yellow
                                            : item.status === "Hold"
                                              ? "#FFC107" // red
                                              : "#F44336", // default gray
                                      flexShrink: 0,
                                    }}
                                  ></span>
                                  <p className="p13 ms-1">{item.status}</p>
                                </div>
                              </div>
                              {/*  </Link> */}
                              {/* {hoveredIndex===index && ( <div
        style={{
          position: "absolute",
          top: "50%",
          right: "1px", transform: 'translate(-50%, -50%)'
        }}
      >
        <div style={{ display:'flex',justifyContent:"start", alignItems:"center",}}>
       {item.status !=="Closed" && item.status !=="Completed" && (<div  onClick={() =>{navigate("/ticket/add", { state: {id: item.id, } });}} style={{display:'flex', alignItems:'center', justifyContent:'center', width:'32px', height:'32px', borderRadius:'100px', background:'#FFFFFF',}}><EditRow/> </div>)} <span style={{marginLeft:'16px'}}></span>
      
        </div>
      </div> )} */}
                            </div>
                          ))}
                        </div>
                      </div>
                      <Row className="mt-3">
                        <Col>
                          <div className="d-flex align-items-center justify-content-start mx-3">
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "#212129",
                              }}
                            >
                              Records per page :
                            </span>
                            <select
                              className="select3"
                              id="perpage"
                              value={itemsPerPage}
                              onChange={(event) => {
                                setItemsPerPage(event.target.value);
                              }}
                              style={{
                                cursor: "pointer",
                                fontFamily: "Satoshi",
                                fontSize: "14px",
                                fontWeight: "500",
                                lineHeight: "18.9px",
                                color: "#212129",
                                width: "52px",
                                height: "24px",
                                borderRadius: "10px",
                                border: "0.7px solid #E5E5E5",
                                padding: "0 4px",
                                backgroundColor: "#FFFFFF",
                              }}
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="30">30</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                        </Col>
                        <Col>
                          <div className="d-flex justify-content-end">
                            <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </>
                )}
                {tabView === "Edit history" &&
                  editHistoryList.length > 0 &&
                  editHistoryList.map((workflow, wIndex) => {
                    let rawDesc = workflow.description ?? "";
                    let remarksText = "";

                    // Extract remarks if wrapped in parenthesis at the end (e.g., "(testing)")
                    const remarksMatch = rawDesc.match(/\(([^)]+)\)\s*$/);
                    if (remarksMatch) {
                      remarksText = remarksMatch[1];
                      rawDesc = rawDesc.slice(0, remarksMatch.index).trim();
                    }

                    // Parse semicolon-separated key-value diffs
                    const items = rawDesc
                      .split(";")
                      .map((s) => s.trim())
                      .filter((s) => s !== "")
                      .map((s) => {
                        const colonIndex = s.indexOf(":");
                        if (colonIndex === -1) {
                          if (s.includes("->")) {
                            return { key: "Change", value: s };
                          }
                          return null;
                        }

                        const key = s.slice(0, colonIndex).trim();
                        const value = s.slice(colonIndex + 1).trim();
                        return { key, value };
                      })
                      .filter(Boolean);

                    const hasStructuredDiffs = items.length > 0 && items.some((item) => item.value?.includes("->"));

                    return (
                      <div
                        key={wIndex}
                        style={{
                          display: "flex",
                          marginTop: wIndex === 0 ? "12px" : "16px",
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "32px", flexShrink: 0 }}>
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              backgroundColor: "#ACB9FF",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexShrink: 0,
                            }}
                          >
                            <img src={editHistory} style={{ margin: "0" }} alt="status" />
                          </div>
                          {editHistoryList.length - 1 !== wIndex && (
                            <div
                              style={{
                                flex: 1,
                                minHeight: "40px",
                                borderLeft: "1px dashed #6929E2",
                                marginTop: "4px",
                                marginBottom: "4px",
                              }}
                            ></div>
                          )}
                        </div>

                        <div
                          style={{
                            flex: 1,
                            marginLeft: "16px",
                            minWidth: 0,
                          }}
                        >
                          <div>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "14px",
                                lineHeight: "18.9px",
                                color: "#212129",
                              }}
                            >
                              {workflow.title ?? ""}
                            </span>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "13px",
                                lineHeight: "18.9px",
                                color: "#6c757d",
                              }}
                            >
                              {" "}
                              ( by {workflow.emp_name ?? ""} )
                            </span>
                          </div>
                          <div style={{ marginTop: "2px", marginBottom: "4px" }}>
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              {workflow.date}
                            </span>
                          </div>
                          <div>
                            {hasStructuredDiffs ? (
                              <>
                                <BulkEditTimeline items={items} />
                                {remarksText && (
                                  <div
                                    style={{
                                      marginTop: "8px",
                                      marginLeft: "28px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      padding: "6px 12px",
                                      backgroundColor: "#F5F6FA",
                                      border: "1px solid #E5E7EB",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <span style={{ fontSize: "12px", fontWeight: "600", color: "#6929E2" }}>Remarks:</span>
                                    <span style={{ fontSize: "12px", color: "#212129", wordBreak: "break-word" }}>{remarksText}</span>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "400",
                                  fontSize: "13px",
                                  lineHeight: "1.5",
                                  color: "#212129",
                                  wordBreak: "break-word",
                                  padding: "8px 12px",
                                  backgroundColor: "#FCFCFE",
                                  border: "1px dashed #D4DDE7",
                                  borderRadius: "12px",
                                  marginTop: "6px",
                                }}
                              >
                                {workflow.description}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {tabView === "Merged Tickets" && ticketDetail?.merged_tickets?.length > 0 && (
                  <div style={{ marginTop: "16px" }}>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "900",
                        fontSize: "11px",
                        lineHeight: "100%",
                        textTransform: "uppercase",
                        color: "#98A1B0",
                        marginBottom: "12px",
                      }}
                    >
                      Merging Tickets : {ticketDetail.merged_tickets.length}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      {ticketDetail.merged_tickets.map((mergedItem, mIndex) => (
                        <div
                          key={mIndex}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            borderRadius: "8px",
                            padding: "6px 12px",
                            background: "#F9F6FF",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/ticket/view/${mergedItem.id}`, { state: { parentId: id || ticketDetail.id, fromTab: "Merged Tickets", listing_type: location.state?.listing_type } });
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "11.5px",
                              lineHeight: "100%",
                              color: "#212129",
                            }}
                          >
                            {mergedItem.code}
                          </span>
                          <span
                            style={{
                              margin: "0 6px",
                              color: "#212129",
                              fontSize: "12px",
                            }}
                          >
                            -
                          </span>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "12px",
                              lineHeight: "100%",
                              color: "#212129",
                              flex: 1,
                              minWidth: 0,
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {mergedItem.title}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Col>
        </Row>
      </div>

      {isImagePreviewOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1200,
            padding: "16px",
          }}
          onClick={closeImagePreview}
        >
          <div
            style={{
              position: "relative",
              width: "min(90vw, 1200px)",
              maxHeight: "90vh",
              backgroundColor: "#FFFFFF",
              borderRadius: "12px",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <span
                style={{
                  fontFamily: "Satoshi",
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#212129",
                  maxWidth: "calc(100% - 40px)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={previewImageName}
              >
                {previewImageName}
              </span>
              <button
                type="button"
                onClick={closeImagePreview}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "22px",
                  lineHeight: 1,
                  cursor: "pointer",
                  color: "#212129",
                }}
              >
                x
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "auto",
              }}
            >
              <img
                src={previewImageUrl}
                alt={previewImageName || "attachment preview"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "calc(90vh - 80px)",
                  objectFit: "contain",
                }}
                onError={closeImagePreview}
              />
            </div>
          </div>
        </div>
      )}

      {isOpenStatusUpdate && (
        <div style={closeModalStyle.overlay}>
          <div style={closeModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    {isOpenHold === true ? "Holding remarks" : ""} {isOpenClose === true ? "Closing remarks" : ""} {isOpenHold === false && isOpenClose === false ? "Completing remarks" : ""}
                  </div>
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "400",
                      color: "#98A1B0",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {subTicketDetail != null ? (subTicketDetail.title ?? "") : (ticketDetail.title ?? "")}
                  </div>
                </div>

                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeStatusUpdateModal} />
              </div>

              <div style={{ marginTop: "8px" }}>
                {isOpenHold === true && (
                  <div>
                    <div
                      style={{
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Expected Date{" "}
                    </div>
                    <div style={{ position: "relative" }}>
                      <DatePicker selected={expectedDate ? (parseTicketDate(expectedDate)?.toDate() ?? null) : null} onChange={handleDateChange} showTimeInput timeInputLabel="Enter Time:" dateFormat="dd-MM-yyyy hh:mm aa" minDate={new Date()} placeholderText="dd-mm-yyyy hh:mm am/pm" wrapperClassName="w-100" popperClassName="expected-date-popper" portalId="portal-root" popperPlacement="bottom-start" popperProps={{ strategy: "fixed" }} customInput={<TicketDateInput />} />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.expected_date}
                    </div>
                  </div>
                )}
                {isOpenClose === true && (
                  <Row>
                    <Col sm={6}>
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Work Duration
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        value={workDuration}
                        onChange={handleChange}
                        onKeyDown={(event) => {
                          setLastKey(event.key);
                        }}
                        placeholder="HH:MM"
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.work_duration}
                      </span>
                    </Col>
                    <Col sm={6}>
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Closing Date
                      </div>
                      <div style={{ position: "relative", height: "40px" }}>
                        {/* Input with Icon */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "0.7px solid #E5E5E5",
                            borderRadius: "8px",
                            padding: "6px 12px",
                          }}
                        >
                          <input
                            type="text"
                            value={closingDate !== null && closingDate !== "" ? formatDate(closingDate) : ""}
                            onClick={() => setShowPicker(!showPicker)}
                            readOnly
                            style={{
                              flex: 1,
                              border: "none",
                              outline: "none",
                              cursor: "pointer",
                            }}
                            placeholder="Select a date"
                          />
                          <CalendarIcon style={{ cursor: "pointer", color: "#842234" }} onClick={() => setShowPicker(!showPicker)} />
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.closing_date}
                        </span>
                        {/* Day Picker */}
                        {showPicker && (
                          <div
                            ref={alertDatePicRef}
                            style={{
                              position: "absolute",
                              top: "50px" /* Moves the picker above the button */,
                              right: 0,
                              zIndex: 100,
                              background: "white",
                              border: "1px solid #ddd",
                              padding: "10px",
                              borderRadius: "5px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                              color: "#21272C",
                            }}
                          >
                            <DayPicker mode="single" selected={closingDate} onSelect={handleClosingDateChange} hidden={{ after: new Date() }} />
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}
                {((subTicketDetail != null && subTicketDetail.status === "Closed") || (subTicketDetail === null && ticketDetail.status === "Closed")) && (
                  <div>
                    <div
                      style={{
                        paddingTop: "6px",
                        paddingBottom: "6x",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Rating
                    </div>
                    <div style={{ display: "flex", justifyContent: "start" }}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span key={star} onClick={() => setRating(star)} style={{ cursor: "pointer", fontSize: "24px" }}>
                          {star <= rating ? <img src={yellowIcon} /> : <img src={greyIcon} />}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <div>
                  <div>
                    <div
                      style={{
                        paddingTop: "6px",
                        marginBottom: "12x",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Description
                    </div>

                    <textarea
                      type="text"
                      placeholder=" "
                      className="form-control"
                      value={descriptionInputValue}
                      rows={6}
                      onChange={(event) => {
                        setDescriptionInputValue(event.target.value); // Update state with input value
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.description}
                    </span>
                  </div>
                </div>

                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "16px",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closeStatusUpdateModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (loading === false) {
                        if (isOpenHold) {
                          statusUpdate("Hold");
                        }
                        if (isOpenClose) {
                          statusUpdate("Closed");
                        }
                        if (!isOpenHold && !isOpenClose) {
                          statusUpdate("Completed");
                        }
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#3253EB",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Submit
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      {ticketOtherDetEdit && (
        <div style={closeEditModalStyle.overlay}>
          <div style={closeEditModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    Other Details Edit
                  </div>
                </div>

                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeticketOtherDetModal} />
              </div>

              <div
                style={{
                  marginTop: "8px",
                  marginBottom: "8px",
                  textAlign: "start",
                }}
              >
                <Row className="mb-3">
                  {isFieldEnabled("Estimation") && (
                    <Col sm={6} className="mt-3">
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                          maxWidth: "100%",
                        }}
                      >
                        {renderFieldLabel("Estimation", "Estimation")}
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        value={estimation}
                        onChange={(event) => {
                          const inputText = event.target.value;
                          if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                            let nextEstimation = inputText;
                            if (lastKey === "Backspace") {
                              nextEstimation = inputText;
                            } else {
                              nextEstimation = inputText.length === 2 ? inputText + ":" : inputText;
                            }

                            setEstimation(nextEstimation);

                            const calculatedExpected = getExpectedDateFromCreateAndEstimation(createdEditDate, nextEstimation);
                            if (calculatedExpected) {
                              setExpectedEditDate(calculatedExpected);
                            }
                          }
                        }}
                        onKeyDown={(event) => {
                          setLastKey(event.key);
                        }}
                        placeholder="HH:MM"
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationsOtherDet.est}
                      </span>
                    </Col>
                  )}
                  {isFieldEnabled("Create Date") && (
                    <Col sm={6} className="mt-3">
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                          maxWidth: "100%",
                        }}
                      >
                        {renderFieldLabel("Create Date", "Created Date")}
                      </div>
                      <DatePicker selected={createdEditDate ? (parseTicketDate(createdEditDate)?.toDate() ?? null) : null} onChange={handleCreateDateChange} showTimeInput timeInputLabel="Enter Time:" dateFormat="dd-MM-yyyy hh:mm aa" minDate={new Date()} placeholderText="dd-mm-yyyy hh:mm am/pm" wrapperClassName="w-100" popperClassName="expected-date-popper" portalId="portal-root" popperPlacement="bottom-start" popperProps={{ strategy: "fixed" }} customInput={<TicketDateInput />} />
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationsOtherDet.created}
                      </span>
                    </Col>
                  )}

                  {isFieldEnabled("Expected Date") && (
                    <Col sm={6} className="mt-3">
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                          maxWidth: "100%",
                        }}
                      >
                        {renderFieldLabel("Expected Date", "Expected Date")}
                      </div>
                      <div style={{ position: "relative" }}>
                        <DatePicker selected={expectedEditDate ? (parseTicketDate(expectedEditDate)?.toDate() ?? null) : null} onChange={handleExpectedDateChange} showTimeInput timeInputLabel="Enter Time:" dateFormat="dd-MM-yyyy hh:mm aa" minDate={createdEditDate ? (parseTicketDate(createdEditDate)?.toDate() ?? null) : new Date()} placeholderText="dd-mm-yyyy hh:mm am/pm" wrapperClassName="w-100" popperClassName="expected-date-popper" portalId="portal-root" popperPlacement="bottom-start" popperProps={{ strategy: "fixed" }} customInput={<TicketDateInput />} />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validationsOtherDet.expected}
                        </span>
                      </div>
                    </Col>
                  )}
                  {isFieldEnabled("Reporter") && (
                    <Col sm={6} className="mt-3">
                      <div style={{ flex: 1 }}>
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "17.55px",
                            color: "#212129",
                            marginBottom: "8px",
                            maxWidth: "100%",
                          }}
                        >
                          {renderFieldLabel("Reporter", "Email")}
                        </p>
                        {<SearchWithAPI onDropdownChange={handleEmailDropdownChange} apiUrl={"get_employee"} params={{}} placeholder={getFieldLabel("Reporter", "Email")} selectedValue={selectedEmailOption != null ? selectedEmailOption.label : ""} selectedOption={selectedEmailOption} />}
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validationsOtherDet.reporter_id}
                        </span>
                      </div>
                    </Col>
                  )}

                  {isFieldEnabled("Team") && (
                    <Col sm={6} className="mt-3">
                      <div style={{ flex: 1 }}>
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "13px",
                            fontWeight: "500",
                            lineHeight: "17.55px",
                            color: "#212129",
                            marginBottom: "8px",
                            maxWidth: "100%",
                          }}
                        >
                          {renderFieldLabel("Team", "Team")}
                        </p>
                        <SearchWithAPI onDropdownChange={handleTeamDropdownChange} apiUrl={"get_team"} placeholder={getFieldLabel("Team", "Team")} selectedValue={selectedTeamOption != null ? selectedTeamOption.label : ""} selectedOption={selectedTeamOption} />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validationsOtherDet.team_id}
                        </span>
                      </div>
                    </Col>
                  )}
                  {isFieldEnabled("Assign To") && (
                    <Col sm={6} className="mt-3">
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                          maxWidth: "100%",
                        }}
                      >
                        {renderFieldLabel("Assign To", "Assign To")}
                      </p>
                      {
                        <SearchWithAPI
                          onDropdownChange={handleAssignToDropdownChange}
                          apiUrl={"get_employee"}
                          params={{
                            team_id: (selectedTeamOption && selectedTeamOption.value) ?? "",
                          }}
                          placeholder={getFieldLabel("Assign To", "Assign To")}
                          selectedValue={selectedAssignToOption != null ? selectedAssignToOption.label : ""}
                          selectedOption={selectedAssignToOption}
                        />
                      }
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationsOtherDet.assignee}
                      </span>
                    </Col>
                  )}
                </Row>
                <Row className="mb-2">
                  <Col sm={12} className="mt-2">
                    <div
                      style={{
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Remarks <span style={{ color: "red" }}> *</span>
                    </div>
                    <textarea
                      rows={3}
                      className="form-control"
                      value={otherRemarks}
                      onChange={(e) => {
                        setOtherRemarks(e.target.value);
                        setValidationsOtherDet((prev) => ({ ...prev, remarks: "" }));
                      }}
                      placeholder="Enter remarks..."
                      style={{
                        borderRadius: "12px",
                        border: validationsOtherDet.remarks ? "1px solid #FF4444" : "1px solid #E5E5E5",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#212129",
                        fontFamily: "Satoshi",
                        padding: "10px 14px",
                        resize: "none",
                      }}
                    />
                    {validationsOtherDet.remarks && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {validationsOtherDet.remarks}
                      </span>
                    )}
                  </Col>
                </Row>
                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "16px",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closeticketOtherDetModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (loading === false) {
                        updateOtherDetails();
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#6929E2",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Update
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpenApproveUpdate && (
        <div style={closeApproveModalStyle.overlay}>
          <div style={closeApproveModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    {isOpenApprove === "approve" ? "Approve Remarks" : ""} {isOpenApprove === "reject" ? "Reject Remarks" : ""}{" "}
                  </div>
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "400",
                      color: "#98A1B0",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {subTicketDetail != null ? (subTicketDetail.title ?? "") : (ticketDetail.title ?? "")}
                  </div>
                </div>

                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeApproveModal} />
              </div>

              <div style={{ marginTop: "8px" }}>
                <div>
                  <div>
                    <div
                      style={{
                        paddingTop: "6px",
                        marginBottom: "12x",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Remarks
                    </div>
                    <textarea
                      type="text"
                      placeholder=" "
                      className="form-control"
                      value={remarksInputValue}
                      rows={6}
                      onChange={(event) => {
                        setRemarksInputValue(event.target.value); // Update state with input value
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.remarks}
                    </span>
                  </div>
                </div>

                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "16px",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closeApproveModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (loading === false) {
                        updateApproval(isOpenApprove === "approve" ? "Approved" : "Rejected");
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: isOpenApprove === "approve" ? "#20824A" : "#FF0000",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      {isOpenApprove === "approve" ? "Approve" : "Reject"}
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      {ticketDesprictionEdit && (
        <div style={closeApproveModalStyle.overlay}>
          <div style={closeApproveModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    Description Edit
                  </div>
                </div>

                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeDescriptionModal} />
              </div>

              <div style={{ marginTop: "8px" }}>
                {isFieldEnabled("Description") && (
                  <div>
                    <div>
                      <div
                        style={{
                          paddingTop: "6px",
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Description
                        {isFieldMandatory("Description") && <span style={{ color: "red" }}> *</span>}
                      </div>
                      <ReactQuill theme="snow" style={{ color: "#212129", minHeight: "150px" }} value={descriptionEdit} onChange={setDescriptionEdit} />
                      {/* <textarea
                      type="text"
                      placeholder=" "
                      className="form-control"
                      value={descriptionEdit}
                      rows={6}
                      onChange={(event) => {
                        setDescriptionEdit(event.target.value); // Update state with input value
                      }}
                    /> */}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationsdescropt.description}
                      </span>
                    </div>
                  </div>
                )}

                {isFieldEnabled("Action Plan") && (
                  <div style={{ marginTop: "16px" }}>
                    <div>
                      <div
                        style={{
                          paddingTop: "6px",
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        {renderFieldLabel("Action Plan", "Action Plan")}
                      </div>
                      <ReactQuill theme="snow" style={{ color: "#212129", minHeight: "150px" }} value={actionPlanEdit} onChange={setActionPlanEdit} />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationsdescropt.action_plan}
                      </span>
                    </div>
                  </div>
                )}

                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "16px",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closeDescriptionModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (loading === false) {
                        updateDescriptionDetails();
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#6929E2",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Update
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      {ticketBillingEdit && (
        <div style={closeEditModalStyle.overlay}>
          <div
            style={{
              ...closeEditModalStyle.modal,
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              overflow: "visible",
            }}
          >
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    Billing Details Edit
                  </div>
                </div>

                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeBillingDetailsModal} />
              </div>

              <div
                style={{
                  marginTop: "8px",
                  display: "flex",
                  flexDirection: "column",
                  height: "auto",
                }}
              >
                <div style={{ overflowY: "visible", paddingRight: "4px" }}>
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "space-between",
                    }}
                  >
                    {" "}
                    <div>
                      <input
                        type="checkbox"
                        id="expected_date"
                        onClick={handleCheckboxChange}
                        checked={isBillingChecked}
                      />
                    </div>
                    <div
                      onClick={() => {
                        setIsBillingChecked(!isBillingChecked);
                        setVendorOption(null);
                        setCustomerOption(null);
                      }}
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "16px",
                        fontWeight: "900",
                        lineHeight: "21.6px",
                        color: "#212129",
                        paddingLeft: "8px",
                      }}
                    >
                      Is this ticket for billing?
                    </div>
                  </div> */}
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                    }}
                  >
                    {validationsbilling.is_billable}
                  </span>
                  {isBillingChecked && (
                    <div className="mb-5">
                      <div className="d-flex" style={{ textAlign: "start", flexWrap: "wrap" }}>
                        {isFieldEnabled("Customer") && (
                          <div className="col-6 ">
                            <div style={{ marginTop: "16px", marginRight: "8px", textAlign: "start" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "8px",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))}
                              </p>

                              <SearchWithAPI onDropdownChange={handleCustomerDropdownChange} apiUrl={`get_client`} placeholder={getFieldLabel("Customer", getFieldLabel("Client Name", "Customer"))} selectedValue={selectedCustomerOption != null ? selectedCustomerOption.label : ""} selectedOption={selectedCustomerOption} />

                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validationsbilling.customer_id}
                              </span>
                            </div>
                          </div>
                        )}

                        {isFieldEnabled("Vendor") && (
                          <div className="col-6">
                            <div style={{ marginTop: "16px", marginRight: "8px", textAlign: "start" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "8px",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Vendor", "Vendor")}
                              </p>

                              <SearchWithAPI onDropdownChange={handleVendorDropdownChange} apiUrl={"get_vendor"} placeholder={getFieldLabel("Vendor", "Vendor")} selectedValue={selectedVendorOption != null ? selectedVendorOption.label : ""} selectedOption={selectedVendorOption} />

                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validationsbilling.vendor_id}
                              </span>
                            </div>
                          </div>
                        )}
                        {isFieldEnabled("Reference") && (
                          <div className="col-6">
                            <div style={{ marginTop: "16px", marginRight: "8px", textAlign: "start" }}>
                              <p
                                style={{
                                  fontFamily: "Satoshi",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  marginBottom: "8px",
                                  maxWidth: "100%",
                                }}
                              >
                                {renderFieldLabel("Reference", "Reference")}
                              </p>

                              <SearchWithAPI onDropdownChange={handleRefernceDropdownChange} apiUrl={"get_refrences"} params={getReferenceParams()} placeholder={getFieldLabel("Reference", "Reference")} selectedValue={selectedReferenceOption != null ? selectedReferenceOption.label : ""} selectedOption={selectedReferenceOption} />

                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validationsbilling.reference_id}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closeBillingDetailsModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (loading === false) {
                        updateBillingDetails();
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#6929E2",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Update
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      {ticketDetEdit && (
        <div style={closeEditModalStyle.overlay}>
          <div style={closeEditModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "4px",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#212129",
                    }}
                  >
                    Ticket Details Edit
                  </div>
                </div>

                <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeticketDetModal} />
              </div>

              <div style={{ marginTop: "8px", textAlign: "start" }}>
                <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
                  {/* Priority Column */}
                  {isFieldEnabled("Priority") && (
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                          maxWidth: "100%",
                        }}
                      >
                        {renderFieldLabel("Priority", "Priority")}
                      </p>
                      <div style={{ position: "relative" }}>
                        <span
                          style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "10px",
                            height: "10px",
                            borderRadius: "3px",
                            backgroundColor: getPriorityColor(priority),
                            pointerEvents: "none",
                          }}
                        ></span>
                        <select
                          className="w-100"
                          id="priority"
                          value={priority}
                          onChange={(event) => setPriority(event.target.value)}
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "18.9px",
                            height: "40px",
                            padding: "10px 10px 10px 32px",

                            borderRadius: "8px",
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            background: "#FFFFFF",
                          }}
                        >
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                          <option value="High">High</option>
                        </select>
                      </div>
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationstickDet.priority}
                      </span>
                    </div>
                  )}
                  {/* Project Column */}
                  {isFieldEnabled("Project") && (
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                          maxWidth: "100%",
                        }}
                      >
                        {renderFieldLabel("Project", "Project")}
                      </p>
                      <SearchWithAPI onDropdownChange={handleProjectDropdownChange} apiUrl={`get_project`} placeholder={getFieldLabel("Project", "Project")} selectedValue={selectedProjectOption != null ? selectedProjectOption.label : ""} selectedOption={selectedProjectOption} />
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validationstickDet.project_id}
                      </div>
                    </div>
                  )}
                </div>

                <div className="level-container">
                  {isFieldEnabled("Level") &&
                    levelOptionList.map((levelOption, index) => (
                      <div className="level-col" key={index}>
                        <p className="level-label" style={{ maxWidth: "100%" }}>
                          {renderFieldLabel(
                            "Level",
                            `${getFieldLabel("Level", "Level")} ${index + 1}`,
                            null,
                            null,
                            index === 0 && isFieldMandatory("Level")
                          )}
                        </p>

                        <SearchWithAPI searchId={index} onChangeIndex={{ parentIndex: index }} onDropdownChange={handleLevelListDropdownChange} apiUrl={index === 0 ? "get_parent_component" : "get_child_component"} params={getLevelParams(index)} placeholder="Search" selectedValue={levelOption != null ? levelOption.label : ""} selectedOption={levelOption} />
                      </div>
                    ))}{" "}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validationstickDet.levels}
                </div>
                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    marginTop: "16px",
                  }}
                >
                  <div
                    onClick={(e) => {
                      closeticketDetModal();
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                      border: "0.6px solid #E5E5E5",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#1E1E1E",
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (loading === false) {
                        updateTicketDetails();
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      width: "176px",
                      height: "44px",
                      marginLeft: "8px",
                      marginRight: "8px",
                      borderRadius: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#6929E2",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                      }}
                    >
                      Update
                    </div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>
  );
};

export default Ticketview;

const Timer = ({ initialSeconds }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    /* if (secondsLeft <= 0) return; */

    const timerId = setInterval(() => {
      setSecondsLeft((prev) => (prev >= 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <div /* style={{ marginBottom: "10px" }} */>
      {/* <span>{formatDuration(secondsLeft)}</span> */}
      <p className="style-justify-start">
        <span className="timm3" style={{ minWidth: "65px" }}>
          {formatDuration(secondsLeft) ?? "00:00"}
        </span>{" "}
        <span>hrs</span>
      </p>
    </div>
  );
};

const formatDuration = (totalSeconds) => {
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const parseDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
